<script setup>
import { computed, onMounted, ref, nextTick, watch } from 'vue';
//import { isProxy, toRaw, getCurrentInstance, onMounted, ref } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { usePage, Link, Head } from '@inertiajs/inertia-vue3';
import { Icon } from '@iconify/vue';
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import Buttons from '@/Components/Buttons.vue';
import CardBoxWidget from "@/Components/CardBoxWidget.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseIcon from "@/Components/BaseIcon.vue";
import {
    mdiAccountMultiple,
    mdiCartOutline,
    mdiChartTimelineVariant,
    mdiMonitorCellphone,
    mdiReload,
    mdiGithub,
    mdiChartPie,
    mdiMagnify,
    mdiDownload,
    mdiGoogleClassroom,
    mdiBook,
    mdiPaperclip,
    mdiEye,
    mdiPrinter,
    mdiCalendarRangeOutline,
    mdiCalendarAccount,
    mdiFileDocument,
    mdiCalendarCheckOutline,
    mdiClockCheck,
    mdiClockRemove,
    mdiMinusThick,
    mdiCloseThick,
    mdiCheckBold,
    mdiClockTimeThreeOutline,
    mdiAccountStar,
    mdiCashFast,
    mdiClockTimeEight,
    mdiChevronRight,
    mdiCogOutline,
    mdiPlus,
    mdiChatProcessingOutline,
    mdiHelp,
    mdiStarOutline,
    mdiStarShootingOutline,
    mdiChatQuestionOutline,
    mdiBookAccountOutline,
    mdiBookOpenVariant,
    mdiFileDocumentMultipleOutline,
    mdiAccountCard,
    mdiFileDocumentMultiple,
    mdiFileCheck,
    mdiChartBar,
    mdiAlertCircle

} from "@mdi/js";
import CardBoxModal from "@/Components/CardBoxModal.vue";
import CardBoxModalPopup from "@/Components/CardBoxModalPopup.vue";
import Preview from "@/Components/Preview.vue";
import constanteApi from "@/conf-global.js";
import { Inertia } from '@inertiajs/inertia';
//import ImageSlider from '@/Components/ImageSlider.vue'
//import $ from 'jquery';
import SectionTitleLineWithButton from "@/Components/SectionTitleLineWithButton.vue";
import SectionTitleLineWithButtonUnens from "@/Components/SectionTitleLineWithButtonUnens.vue";
import CardBoxCourse from "@/Components/CardBoxCourse.vue";

import * as chartConfig from "@/Components/Charts/radarchart.config.js";// <-- LRR Se usa radarchart  y no chart.config.js que para linear
//import LineChart from "@/Components/Charts/LineChart.vue";
import RadarChart from "@/Components/Charts/RadarChart.vue";// Example <-- cambiar a sólo RadarChart y no Example
import BarChart from "@/Components/Charts/BarChart.vue";
import CompetencyGraphic from "@/Components/CompetencyGraphic.vue";
import CardBox from "@/Components/CardBox.vue";
import UnensNavLink from '@/Components/NavLink.vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';// <-- https://splidejs.com/integration/vue-splide/
import DoughnutChart from "@/Components/Charts/DoughnutChart.vue";// Example <-- cambiar a sólo RadarChart y no Example

// Componentes modulares y reutilizables del Dashboard
import StudentDocumentsCard from "@/Components/Dashboard/StudentDocumentsCard.vue";
import StudentComunicadosCard from "@/Components/Dashboard/StudentComunicadosCard.vue";
import AdminAlertsCard from "@/Components/Dashboard/AdminAlertsCard.vue";
import AdminMetricsGrid from "@/Components/Dashboard/AdminMetricsGrid.vue";
import AdminStorageCard from "@/Components/Dashboard/AdminStorageCard.vue";

/* const props = defineProps({
    
}); */

/* const slides = [
    'https://images.unsplash.com/photo-1544427920-c49ccfb85579?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1422&q=80',
    'https://images.unsplash.com/photo-1544144433-d50aff500b91?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80'
    //'https://source.unsplash.com/random/800x400?i=1',
    //'https://source.unsplash.com/random/800x400?i=2',
    //'https://source.unsplash.com/random/800x400?i=3',
    //'https://source.unsplash.com/random/800x400?i=4',
    //'https://source.unsplash.com/random/800x400?i=5',
    //'https://source.unsplash.com/random/800x400?i=6',
] */

// Gráfica
/*     const chartData = ref(null);

    const fillChartData = () => {
    chartData.value = chartConfig.sampleChartData();
    };
 */
/*    onMounted(() => {
   fillChartData();
   }); */
//console.log(chartData)

/*     const listarFiles = (criterio, buscar) => {
        //const ruta = 'fileforlevel-' + props.ruta// + '?criterio=' + criterio + '&buscar=' + buscar
        const ruta = 'fileforlevel-file-filesforleve'// + '?criterio=' + criterio + '&buscar=' + buscar

        Inertia.get(route(ruta, {
            'criterio': criterio,
            'buscar': buscar
        }
        ))

        buscarCriterio.value = ''
        //}
    } */



// listar documentos
//const confGlobal = props.connstantes 
const isModalFiles = ref(true)

const user = computed(() => usePage().props.value.auth.user);
const userRole = computed(() => user.value?.id_rol);
const userRolType = computed(() => user.value?.rol_type);

onMounted(() => {
    const role = userRole.value;
    const type = userRolType.value;

    // Load only necessary data based on user type & role for optimal load efficiency
    if (role <= 6 || type === 'admin' || type === 'coordinador' || type === 'secretaria') {
        contadorAlumnosActivos();
        getDataStudents();
        loadAdminAlerts();
    }

    if (role <= 4 || type === 'secretaria') {
        getChartStatusDisk();
    }

    if (type === 'maestro' || type === 'tutor' || type === 'coordinador' || type === 'secretaria') {
        getDataAsistencia();
    }

    if (type === 'estudiante' || type === 'apoderado') {
        listarMark();
        listarFilesForLevel();
        if (user.value?.has_classroom) {
            listarChartCalification();
            loadStudentExamRanking();
            listarAdmisionPuntaje();
            listarTareas();
        }
    }

    // Cargar comunicados institucionales activos y pendientes
    loadActiveComunicados();
});

// --- AGENDA Y HORARIO DEL ESTUDIANTE ---
const getLocalDateString = (d = new Date()) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const isStudentAgendaModalOpen = ref(false);
const studentAgendaLoading = ref(false);
const studentAgendaData = ref(null);
const studentAgendaTab = ref('agenda'); // 'agenda' | 'horario'
const studentAgendaDate = ref(getLocalDateString());

const daysOfWeekList = [
    { id: 1, label: 'Lunes' },
    { id: 2, label: 'Martes' },
    { id: 3, label: 'Miércoles' },
    { id: 4, label: 'Jueves' },
    { id: 5, label: 'Viernes' },
];

const loadStudentAgenda = (date) => {
    studentAgendaLoading.value = true;
    const targetDate = date || studentAgendaDate.value;
    axios.get(route('student.dashboard.agenda'), {
        params: { date: targetDate }
    }).then(res => {
        if (res.data.success) {
            studentAgendaData.value = res.data;
        }
    }).catch(err => {
        console.error(err);
    }).finally(() => {
        studentAgendaLoading.value = false;
    });
};

const openStudentAgendaModal = () => {
    studentAgendaTab.value = 'agenda';
    isStudentAgendaModalOpen.value = true;
    loadStudentAgenda(studentAgendaDate.value);
};

const openStudentHorarioModal = () => {
    studentAgendaTab.value = 'horario';
    isStudentAgendaModalOpen.value = true;
    loadStudentAgenda(studentAgendaDate.value);
};

const changeStudentAgendaDate = (deltaDays) => {
    const [y, m, d] = (studentAgendaDate.value || getLocalDateString()).split('-').map(Number);
    const current = new Date(y, m - 1, d);
    current.setDate(current.getDate() + deltaDays);
    const newDateStr = getLocalDateString(current);
    studentAgendaDate.value = newDateStr;
    loadStudentAgenda(newDateStr);
};

// --- COMUNICADOS INSTITUCIONALES (WIDGET Y MODAL EMERGENTE) ---
const comunicadosList = ref([]);
const pendingComunicados = ref([]);
const currentStudentId = ref(null);
const isComunicadoPopupOpen = ref(false);
const popupScrollContainer = ref(null);
const hasScrolledToBottom = ref(false);
const popupAcceptanceChecked = ref(false);
const selectedPopupIndex = ref(0);
const isSubmittingAcceptance = ref(false);

// Modal de detalle individual desde el widget
const isComunicadoDetailOpen = ref(false);
const selectedComunicado = ref(null);

const currentPopupComunicado = computed(() => {
    if (pendingComunicados.value.length > 0 && selectedPopupIndex.value < pendingComunicados.value.length) {
        return pendingComunicados.value[selectedPopupIndex.value];
    }
    return null;
});

const canAcceptCurrentComunicado = computed(() => {
    if (!currentPopupComunicado.value) return false;
    // Obligatorio: debe haber hecho scroll hasta el fondo
    if (!hasScrolledToBottom.value) return false;
    // Si requiere aceptación, la casilla debe estar marcada
    if (currentPopupComunicado.value.requires_acceptance && !popupAcceptanceChecked.value) {
        return false;
    }
    return true;
});

const checkScrollNeeded = () => {
    nextTick(() => {
        const el = popupScrollContainer.value;
        if (!el) {
            hasScrolledToBottom.value = true;
            return;
        }
        if (el.scrollHeight <= el.clientHeight + 30) {
            hasScrolledToBottom.value = true;
        } else {
            hasScrolledToBottom.value = false;
        }
    });
};

const handlePopupScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop - clientHeight <= 35) {
        hasScrolledToBottom.value = true;
    }
};

const selectPopupComunicado = (index) => {
    selectedPopupIndex.value = index;
    popupAcceptanceChecked.value = false;
    checkScrollNeeded();
};

const loadingComunicados = ref(false);
const errorComunicados = ref(null);

const loadActiveComunicados = () => {
    loadingComunicados.value = true;
    errorComunicados.value = null;

    axios.get(route('comunicados-active-for-user'), { timeout: 10000 })
        .then(res => {
            if (res.data) {
                comunicadosList.value = res.data.all || [];
                pendingComunicados.value = res.data.pending || [];
                currentStudentId.value = res.data.student_id || null;

                if (pendingComunicados.value.length > 0) {
                    selectedPopupIndex.value = 0;
                    popupAcceptanceChecked.value = false;
                    isComunicadoPopupOpen.value = true;
                    checkScrollNeeded();
                }
            }
        })
        .catch(err => {
            console.warn('Error al cargar comunicados:', err);
            errorComunicados.value = 'No se pudieron cargar los comunicados.';
        })
        .finally(() => {
            loadingComunicados.value = false;
        });
};

const acceptCurrentComunicado = () => {
    if (!canAcceptCurrentComunicado.value || !currentPopupComunicado.value) return;

    isSubmittingAcceptance.value = true;
    const item = currentPopupComunicado.value;

    axios.post(route('comunicados-accept'), {
        comunicado_id: item.id,
        student_id: currentStudentId.value
    }).then(() => {
        // Actualizar estado leído en comunicadosList
        const found = comunicadosList.value.find(c => c.id === item.id);
        if (found) found.is_accepted = true;

        // Quitar de la lista de pendientes
        pendingComunicados.value.splice(selectedPopupIndex.value, 1);

        if (pendingComunicados.value.length > 0) {
            if (selectedPopupIndex.value >= pendingComunicados.value.length) {
                selectedPopupIndex.value = pendingComunicados.value.length - 1;
            }
            popupAcceptanceChecked.value = false;
            checkScrollNeeded();
        } else {
            isComunicadoPopupOpen.value = false;
        }
    }).catch(err => {
        console.error('Error al confirmar comunicado:', err);
    }).finally(() => {
        isSubmittingAcceptance.value = false;
    });
};

const openComunicadoDetail = (comunicado) => {
    selectedComunicado.value = comunicado;
    isComunicadoDetailOpen.value = true;
};
const anuncios = ref([])

const arrayAlertCloseCalifications = ref({});
const arrayAlertShowCalifications = ref({});
const arrayAlertPublishCalifications = ref({});

const loadingAdminAlerts = ref(false);
const errorAdminAlerts = ref(null);

const loadAdminAlerts = () => {
    loadingAdminAlerts.value = true;
    errorAdminAlerts.value = null;

    Promise.allSettled([
        axios.get('/calification/alertclosecalifications', { timeout: 10000 }),
        axios.get('/calification/alertshowcalifications', { timeout: 10000 }),
        axios.get('/calification/alertpublishcalifications', { timeout: 10000 }),
    ]).then(results => {
        if (results[0].status === 'fulfilled') {
            arrayAlertCloseCalifications.value = results[0].value.data || {};
        }
        if (results[1].status === 'fulfilled') {
            arrayAlertShowCalifications.value = results[1].value.data || {};
        }
        if (results[2].status === 'fulfilled') {
            arrayAlertPublishCalifications.value = results[2].value.data || {};
        }
    }).catch(err => {
        console.warn('Error cargando alertas de calificaciones:', err);
        errorAdminAlerts.value = 'No se pudieron cargar las alertas académicas.';
    }).finally(() => {
        loadingAdminAlerts.value = false;
    });
};

const alertCloseCalifications = () => loadAdminAlerts();
const alertShowCalifications = () => loadAdminAlerts();
const alertPublishCalifications = () => loadAdminAlerts();

const studentExamSelectedCiclo = ref('');
const studentExamRankingData = ref(null);
const studentExamRankingLoading = ref(false);
const loadStudentExamRanking = (ref_ciclo = '') => {
    studentExamRankingLoading.value = true;
    let url = '/calification/student-exam-ranking' + (ref_ciclo ? '?ref_ciclo=' + ref_ciclo : '');
    axios.get(url).then(function (response) {
        studentExamRankingData.value = response.data;
        if (!studentExamSelectedCiclo.value && response.data.ref_ciclo) {
            studentExamSelectedCiclo.value = response.data.ref_ciclo;
        }
    }).catch(function (error) {
        console.error(error);
    }).finally(() => {
        studentExamRankingLoading.value = false;
    });
};

/**
 * Get asistencia
 */


const arrayLastStudents = ref([])
const getDataStudents = () => {
    let url = '/student/getfordashboard';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayLastStudents.value = respuesta.laststudents
        //console.log(arrayLastStudents.value);
    }).catch(function (error) {
        //console.log(error);
    });
}

/**
 * Get asistencia
 */
const cantTardanzas = ref(0)
const cantFaltas = ref(0)
const arrayAsistencia = ref(null)
const getDataAsistencia = () => {
    //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/asistenciacolaborador/getfordashboard';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayAsistencia.value = respuesta.datalist
        //console.log(arrayAsistencia.value);
    }).catch(function (error) {
        //console.log(error);
    });
}

/* onMounted(() => {
    listarChartCalification()
}); */
const chartCalifications = ref(null)// <-- Estaba en Array y generaba error con un labels y datasets adicionales
const chartSelectCiclo = ref(null);
const publicarNotas = ref(false);
const publicarLibreta = ref(false);
const rangoLibreta = ref('');
const listarChartCalification = (ref_ciclo = '', origin_type = 'dash_student') => {
    //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/calification/grafica' + '?ref_ciclo=' + ref_ciclo + '&origin_type=' + origin_type;

    if (ref_ciclo) {
        chartCalifications.value = null // <-- Limpiar value si se vuelve a consultar y no dejarlo en array
    }

    axios.get(url).then(function (response) {
        let respuesta = response.data;
        chartCalifications.value = respuesta.datachart// El return directo del array trae otros datos que generan error para el chart
        chartSelectCiclo.value = respuesta.refciclo
        publicarNotas.value = respuesta.publicarnotas
        publicarLibreta.value = respuesta.publicarlibreta
        rangoLibreta.value = respuesta.rangolibreta || ''
        //console.log('B: ' + ref_ciclo)
        //console.log(chartCalifications.value);
        //console.log(chartSelectCiclo.value);
    }).catch(function (error) {
        //console.log(error);
    });
}

const filesForLevel = ref([])
const isStudentPreviewActive = ref(false);
const studentPreviewFile = ref(null);

const formatLocalDate = (dateStr) => {
    if (!dateStr) return '';
    const parts = dateStr.split('-');
    if (parts.length === 3) {
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return dateStr;
};

const openStudentPreview = (file) => {
    studentPreviewFile.value = {
        id: file.id,
        name: file.name,
        filename: file.filename,
        filepath: file.filepath,
        type: file.filename ? file.filename.split('.').pop() : ''
    };
    isStudentPreviewActive.value = true;
};

const loadingFilesForLevel = ref(false);
const errorFilesForLevel = ref(null);

const listarFilesForLevel = () => {
    loadingFilesForLevel.value = true;
    errorFilesForLevel.value = null;
    axios.get('/file/listfilesforlevel', { timeout: 10000 }).then(function (response) {
        var respuesta = response.data;
        filesForLevel.value = respuesta.files || [];
    }).catch(function (error) {
        console.warn('Error en /file/listfilesforlevel:', error);
        errorFilesForLevel.value = 'No se pudieron cargar los documentos de nivel.';
    }).finally(() => {
        loadingFilesForLevel.value = false;
    });
};

const haveEAP = ref(0)
const arrayAdmisionPuntaje = ref([])
const listarAdmisionPuntaje = () => {
    let url = '/admisionpuntaje/dashboard';
    axios.get(url).then(function (response) {
        var respuesta = response.data;
        arrayAdmisionPuntaje.value = respuesta.admisionpuntajes;
        haveEAP.value = respuesta.haveEAP;
        //console.log(filesForLevel.value);
    }).catch(function (error) {
        //console.log(error);
    });
}

const countTareaWithOutResp = ref(0)
const arrayTareas = ref([])
const listarTareas = () => {
    let url = '/task/dashboard';
    axios.get(url).then(function (response) {
        var respuesta = response.data;
        arrayTareas.value = respuesta.tareas;
        countTareaWithOutResp.value = respuesta.countTareaWithOutResp;
        //console.log(arrayTareas.value);
        //console.log(countTareaWithOutResp.value);
    }).catch(function (error) {
        //console.log(error);
    });
}

const studentActives = ref(0)
const studentInactives = ref(0)
const studentNews = ref(0)
const studentOlds = ref(0)
const studentTotal = ref(0)

const loadingAdminMetrics = ref(false);
const errorAdminMetrics = ref(null);

const contadorAlumnosActivos = () => {
    loadingAdminMetrics.value = true;
    errorAdminMetrics.value = null;
    axios.get('/student/count', { timeout: 10000 }).then(function (response) {
        var respuesta = response.data;
        studentActives.value = respuesta.studentActives || 0;
        studentInactives.value = respuesta.studentInactives || 0;
        studentNews.value = respuesta.studentNews || 0;
        studentOlds.value = respuesta.studentOlds || 0;
        studentTotal.value = respuesta.studentTotal || 0;
    }).catch(function (error) {
        console.warn('Error en /student/count:', error);
        errorAdminMetrics.value = 'No se pudieron cargar las métricas de alumnos.';
    }).finally(() => {
        loadingAdminMetrics.value = false;
    });
};

const arrayMarks = ref([])
const asistenciaHoy = ref(null)
const conductaSemanal = ref(null)
const listarMark = () => {
    let url = '/mark/dashboard';
    axios.get(url).then(function (response) {
        var respuesta = response.data;
        arrayMarks.value = respuesta.data;
        asistenciaHoy.value = respuesta.asistenciahoy;
        conductaSemanal.value = respuesta.conductasemanal;
        //console.log(arrayMarks.value);
    }).catch(function (error) {
        //console.log(error);
    });
}

// Status of disk
const chartStatusDisk = ref(null);
const loadingStorageDisk = ref(false);
const errorStorageDisk = ref(null);

const getChartStatusDisk = () => {
    loadingStorageDisk.value = true;
    errorStorageDisk.value = null;
    axios.get('/home/statusdisk', { timeout: 10000 }).then(function (response) {
        let respuesta = response.data;
        chartStatusDisk.value = respuesta.chartDisk;
        if (respuesta.alertDisk > 0) {
            let anunObject = {
                'title': 'Almacenamiento disponible ha llegado al límite recomendado',
                'content': 'Debe eliminar documentos antiguos o aumentar la capacidad de almacenamiento',
                'date': ''
            };
            anuncios.value.push(anunObject);
        }
    }).catch(function (error) {
        console.warn('Error en /home/statusdisk:', error);
        errorStorageDisk.value = 'No se pudo consultar el uso de disco.';
    }).finally(() => {
        loadingStorageDisk.value = false;
    });
};

//console.log(filesForLevel.value.length)

//const formsLength = computed(() => filesForLevel.value.length)
//const existFilesForLevel = filesForLevel.value;
//console.log(formsLength)
//if (formsLength > 0) {
//isModalFiles.value = true
//} 

//onst app = getCurrentInstance()
//const constGlobal = app.appContext.config.globalProperties.confGlobalStr
//app.provide('progressBar', app.config.globalProperties.$Progress)
//console.log(constGlobal);

//const { proxy } = getCurrentInstance();
//console.log(proxy.versionApp)
//const globali = proxy.confGlobal
//console.log(globali)

//const props = defineProps({
//confGlobalVal: confGlobal.value
//});

/*
// LRR
//const confGlobal = props.connstantes
const confGlobalVal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobalVal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        //console.log(error);
  });
});

//console.log(confGlobalVal.value);
*/

//const confGlobal = ref($confGlobal)

//onMounted(() => this.confGlobal)

//confGlobalVal.value = constantes

//console.log(confGlobalVal.INICIO_SHOW_MODAL_MENSAJE);

//const confGlobalVal = getConstantes
//confGlobalVal = constantes
//console.log(confGlobalVal);

//let rawData = confGlobalVal.value;

//if (isProxy(confGlobalVal.value)){
//rawData = toRaw(confGlobalVal.value)
//console.log('ProxyLe: ', rawData)
//}

//const reqObject = JSON.parse(JSON.stringify(confGlobalVal.value));
//console.log('request', reqObject);
//console.log(props.confGlobal);

// LRR usar constanteApi /************************************************************************** Reviasr constantes en script pendiente  */
//let constGlobal = 'Hola'
/*const getConstantes = async() => {
  try {
    //- LRR const resp = await constanteApi.get('/global')
    //console.log(resp)
    const { data } = await constanteApi.get('/global')
    const { constantes } = data
    //console.log(constantes)
    const constGlobal = 'Good'

  } catch (error) {
    //console.log('Error al consultar constantes', error)
    throw error
  }
}
getConstantes()
*/
//console.log(constGlobal.value)


const isModalInicioActive = ref(true)
//if (confGlobal.INICIO_SHOW_MODAL_MENSAJE == '1') {
//isModalInicioActive.value = 1;
//}
const isModalFullActive = ref(false);
const modalFullSrc = ref('');

const isConfirm = () => {
    //cleanVal()
}
const isCancel = () => {
    cleanVal()
}
const showingTabDropdown = ref(false);

const cleanVal = () => {
    modalFullSrc.value = ''

}

/*let myRadios = document.getElementsByName('tabs2');
let setCheck;
let x = 0;
for (x = 0; x < myRadios.length; x++) {
    myRadios[x].onclick = function () {
        if (setCheck != this) {
            setCheck = this;
        } else {
            this.checked = false;
            setCheck = null;
        }
    };
}
*/

const data = {
    "files": [
        { "id": 1, "course": "Matemática", "maestro": "Lenin Rivas", "progress": 71 },
        { "id": 2, "course": "Lenguaje", "maestro": "Lucy Farroñay", "progress": 68 },
        { "id": 3, "course": "Arte", "maestro": "Jorge el Curioso", "progress": 49 },
        { "id": 3, "course": "Sociedad y Ambiente", "maestro": "Dora la Exploradora", "progress": 36 },

    ]
};
const data2 = {
    "files": [
        { "id": 1, "course": "Física", "maestro": "Juan Rivas", "progress": 80 },
        { "id": 2, "course": "Química", "maestro": "Eduardo Otero", "progress": 70 },
        { "id": 3, "course": "Biología", "maestro": "Pilar Ramirez", "progress": 49 },
        { "id": 3, "course": "Educación física", "maestro": "Leon Van Damme", "progress": 31 },

    ]
};

// Silder >>> OBSOLETO
/* var cont = 0;
const loopSlider = () => {
    const xx = setInterval(() => {
        switch (cont) {
            case 0: {
                $("#slider-1").fadeOut(400);
                $("#slider-2").delay(400).fadeIn(400);
                //$("#sButton1").removeClass("bg-purple-800");
                //$("#sButton2").addClass("bg-purple-800");
                cont = 1;

                break;
            }
            case 1:
            {

                $("#slider-2").fadeOut(400);
                $("#slider-1").delay(400).fadeIn(400);
                //$("#sButton2").removeClass("bg-purple-800");
                //$("#sButton1").addClass("bg-purple-800");

                cont = 0;

                break;
            }


        }
    }, 8000);

}

const reinitLoop = (time) => {
    //clearInterval(xx);
    setTimeout(loopSlider(), time);
}



const sliderButton1 = () => {
    //$(‘id’);
    $("#slider-2").fadeOut(400);
    $("#slider-1").delay(400).fadeIn(400);
    $("#sButton2").removeClass("bg-purple-800");
    $("#sButton1").addClass("bg-purple-800");
    reinitLoop(4000);
    cont = 0

}

const sliderButton2 = () => {
    $("#slider-1").fadeOut(400);
    $("#slider-2").delay(400).fadeIn(400);
    $("#sButton1").removeClass("bg-purple-800");
    $("#sButton2").addClass("bg-purple-800");
    reinitLoop(4000);
    cont = 1

}

//$(window).ready(function(){
// $("#slider-2").hide();
//$$("#sButton1").addClass("bg-purple-800");


//loopSlider();


//});
onMounted(() => {
    $("#slider-2").hide();
    //$("#sButton1").addClass("bg-purple-800");


    loopSlider();
});
    // Fin de slider */

// Formatos de fecha y tiempo
const formatDate = (datesource) => {
    //var now = new Date().toLocaleDateString()
    if (datesource) {
        var date = new Date(datesource + 'T00:00:00')// <-- Con let no funcionaba <-- Agregar la hora para que no reste un día por la zona horaria del navegador
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
        return result
    }

}

//console.log(props.object)
const formatDateTime = (datetime) => {
    if (datetime) {
        var date = new Date(datetime)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
        return result
    }

}

</script>

<template>

    <Head title="Inicio" />

    <BreezeAuthenticatedLayout>
        <!-- <div class="group fixed bottom-0 right-0 p-4 flex items-end justify-end w-24 h-24 ">
           
            <div class="text-white shadow-lg border flex items-center justify-center p-4 rounded-full bg-blue-600 z-50 absolute  ">
                <BaseIcon :path="mdiPlus" :size="26" class="text-white" />
            </div>
            
            <div class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-y-0 group-hover:scale-y-100 group-hover:-translate-x-16 flex  p-3 hover:p-3 bg-green-300 scale-100 hover:bg-green-400 text-white">
                <BaseIcon :path="mdiChatProcessingOutline" :size="26" class="text-white" />
            </div>
            
            <div class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-x-0 group-hover:scale-x-100 group-hover:-translate-y-16  flex  p-3 hover:p-3 bg-blue-300 hover:bg-blue-400  text-white">
                <BaseIcon :path="mdiCogOutline" :size="26" class="text-white" />
            </div>
           
            <div class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-x-0 group-hover:scale-x-100 group-hover:-translate-y-14 group-hover:-translate-x-14   flex  p-3 hover:p-3 bg-yellow-300 hover:bg-yellow-400 text-white">
                <BaseIcon :path="mdiCogOutline" :size="26" class="text-white" />
            </div>
        </div> -->

        <!-- Botón Ayuda -->
        <div class="group fixed bottom-0 right-0 p-4 flex items-end justify-center w-24 h-36">
            <!-- 6 secretaria, 5 coordinador, 4, admincoord 3 adminsitrador, 2 gerencial, TI -->
            <template v-if="$page.props.auth.user.id_rol <= 6">
                <template v-if="confGlobal.value.MAIN_SUPPORT_CHAT_URL">
                    <div class="text-white shadow-lg border flex items-center justify-center p-4 rounded-full bg-blue-600 hover:bg-blue-800 z-50 absolute" title="Necesitas ayuda?">
                        <BaseIcon :path="mdiChatQuestionOutline" :size="26" class="text-white" />
                    </div>
                    <a :href="confGlobal.value.MAIN_SUPPORT_CHAT_URL" target="_blank" class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-y-0 group-hover:scale-y-100 group-hover:-translate-y-16 flex  p-3 hover:p-3 bg-green-500 scale-100 hover:bg-green-600 text-white" style="margin-bottom: 52px">
                        <BaseIcon :path="mdiChatProcessingOutline" :size="26" class="text-white" />
                    </a>
                    <Link :href="route('help')" class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-y-0 group-hover:scale-y-100 group-hover:-translate-y-16 flex  p-3 hover:p-3 bg-red-500 scale-100 hover:bg-red-700 text-white">
                        <BaseIcon :path="mdiHelp" :size="26" class="text-white" />
                    </Link>
                </template>
                <template v-else>
                    <Link :href="route('help')" class="text-white shadow-lg border flex items-center justify-center p-4 rounded-full bg-red-600 hover:bg-red-800 z-50 absolute" title="Necesitas ayuda?">
                        <BaseIcon :path="mdiHelp" :size="26" class="text-white" />
                    </Link>
                </template>
            </template>
            <!-- Estudiante o apoderado -->
            <template v-else-if="($page.props.auth.user.id_rol == 8 || $page.props.auth.user.id_rol == 9)">
                <template v-if="confGlobal.value.STUDENT_SUPPORT_CHAT_URL">
                    <div class="text-white shadow-lg border flex items-center justify-center p-4 rounded-full bg-blue-600 hover:bg-blue-800 z-50 absolute" title="Necesitas ayuda?">
                        <BaseIcon :path="mdiChatQuestionOutline" :size="26" class="text-white" />
                    </div>
                    <a :href="confGlobal.value.STUDENT_SUPPORT_CHAT_URL" target="_blank" class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-y-0 group-hover:scale-y-100 group-hover:-translate-y-16 flex  p-3 hover:p-3 bg-green-500 scale-100 hover:bg-green-600 text-white" style="margin-bottom: 52px">
                        <BaseIcon :path="mdiChatProcessingOutline" :size="26" class="text-white" />
                    </a>
                    <Link :href="route('help')" class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-y-0 group-hover:scale-y-100 group-hover:-translate-y-16 flex  p-3 hover:p-3 bg-red-500 scale-100 hover:bg-red-700 text-white">
                        <BaseIcon :path="mdiHelp" :size="26" class="text-white" />
                    </Link>
                </template>
                <template v-else>
                    <Link :href="route('help')" class="text-white shadow-lg border flex items-center justify-center p-4 rounded-full bg-red-600 hover:bg-red-800 z-50 absolute" title="Necesitas ayuda?">
                        <BaseIcon :path="mdiHelp" :size="26" class="text-white" />
                    </Link>
                </template>
            </template>
            <!-- Todos los demas -->
            <template v-else>
                <Link :href="route('help')" class="text-white shadow-lg border flex items-center justify-center p-4 rounded-full bg-red-600 hover:bg-red-800 z-50 absolute" title="Necesitas ayuda?">
                    <BaseIcon :path="mdiHelp" :size="26" class="text-white" />
                </Link>
            </template>

        </div>
        <!-- <div class="md:col-span-2 md:h-full h-48 col-span-1 rounded-t-lg bg-cover bg-center md:rounded-none md:rounded-l-lg"
                        style="background-image: url(/img/dashboard/popup-01.jpg);">

                    </div>
                    <div class="md:col-span-3 col-span-1 p-6 items-center h-full flex bg-cover bg-center md:rounded-r-lg rounded-b-lg"
                        style="background-image: url(/img/dashboard/bg-popup.png);">
                        <div>
                            <div class="mb-8">
                                <p class="text-sm text-gray-600 flex items-center">
                                    Estamos Contigo.
                                </p>
                                <div class="text-gray-900 font-bold lg:text-2xl text-xl mb-2">
                                    Volverte a ver ¡Nos emociona!
                                </div>
                                <p class="text-gray-700 lg:text-base text-sm">Nos hace muy felices tenerte de regreso. Si
                                    eres alumno
                                    nuevo, sabemos que lo disfrutaras al máximo.
                                    Con nosotros podras obtener la mejor modalidad de estudios para tus beneficios.
                                    <br>
                                    <br>
                                    ¿Tienes dudas?
                                </p>
                            </div>
                            <div class="flex items-center">
                                <a :href="route('help')" class="btn btn-rose mb-4">Clic Aquí</a>
                            </div>
                        </div>

                    </div> -->
        <!-- Modal de comunicados si moodal mensaje está activo -->
        <template v-if="confGlobal.value.INICIO_SHOW_MODAL_MENSAJE == '1' && anuncios.length > 0">
            <CardBoxModalPopup v-model="isModalInicioActive" title="Aviso" size-modal="modal-4" noPadding class="p-4" hasCancel>
                <div class="grid grid-cols-1 h-full">
                    <div class="col-span-1 p-6 flex bg-cover bg-center rounded-lg max-h-[600px]" style="background-image: url(/img/dashboard/bg-popup.png);">
                        <div class="w-full max-h-[552px]">
                            <div class="text-gray-900 font-bold lg:text-2xl text-xl mb-4">
                                Anuncios
                            </div>
                            <div class="grid grid-cols-1 gap-3 mb-4 overflow-y-auto max-h-[450px]">
                                <div v-for="(anuncio, index) in anuncios" :key="index" class="border rounded-md p-3 bg-white">
                                    <div class="flex justify-between mb-2">
                                        <div>
                                            <h1 class="font-semibold text-base">{{ anuncio.title }}</h1>
                                        </div>
                                        <div v-if="anuncio.date" class="flex items-center">
                                            <BaseIcon :path="mdiClockTimeEight" :size="20" class="text-lime-400 mr-2" />
                                            <p class="text-xs">{{ anuncio.date }}</p>
                                        </div>
                                    </div>
                                    <div class="text-sm" v-html="anuncio.content"></div>
                                </div>
                                <!-- <div class="border rounded-md p-3 bg-white">
                                    <div class="flex justify-between mb-2">
                                        <div>
                                            <h1 class="font-semibold text-base">Dirección</h1>
                                        </div>
                                        <div class="flex items-center">
                                            <BaseIcon :path="mdiClockTimeEight" :size="20" class="text-lime-400 mr-2" />
                                            <p class="text-xs">03/10 18:50</p>
                                        </div>
                                    </div>
                                    <p class="text-sm">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum, libero!</p>
                                </div> -->
                            </div>
                            <div class="flex items-center">
                                <!-- <a :href="route('help')" class="btn btn-rose mb-0">100% Leído</a> -->
                                <a href="#" class="btn btn-rose mb-0" @click="isModalInicioActive = false">Aceptar</a>
                            </div>
                        </div>

                    </div>
                </div>
            </CardBoxModalPopup>
            <!-- <CardBoxModal v-if="confGlobal.value.INICIO_SHOW_MODAL_DOCUMENTS == '1'" v-model="isModalInicioActive" title="Documents">
                <p>Recuerda recuerda <b>recuerda</b></p>
                <p>Ejemplo de Modal</p>
                
                <div >
                    <p class="p-5"><b>Documentos</b>
                    </p>
                    <table>
                        <thead>
                            <tr>
                                <th>Descripción</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="client in filesForLevel" :key="client.id">
                                <td data-label="Descripción">
                                    <BaseIcon v-if="client.type == 'PDF'" :path="mdiPaperclip" :size="32"
                                        class="text-red-600" />
                                    <BaseIcon v-else :path="mdiPaperclip" :size="32" class="text-lime-600" />

                                    {{ client.name }}
                                </td>
                                <td class="before:hidden lg:w-1 whitespace-nowrap">
                                    <BaseButtons type="justify-start lg:justify-end" no-wrap>


                                        <BaseButton color="" :icon="mdiDownload" small label="Descargar" @click=""
                                            :href="route('file-download', { 'srcid': (client.src_object_id ? client.src_object_id : 0), 'filename': client.filename })"
                                            target="_blank"
                                            class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 mr-3 last:mr-0 mb-3" />


                                    </BaseButtons>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CardBoxModal> -->
        </template>

        <!-- Vista previa Modal -->
        <CardBoxModal v-model="isModalFullActive" title="Vista previa" sizeModal="full" hasCancel><!-- tien el botón de cancelar superior-->
            <div class="flex justify-center w-full">
                <embed :src="modalFullSrc" class="min-h-[80vh] max-h-[80vh] lg:min-h-[80vh] w-full"><!-- w-full es para documetnos w-auto para imágenes-->
            </div>
        </CardBoxModal>

        <template #header>
            <PremiumPageHeader :title="'¡Hola, ' + $page.props.auth.user.name + '!'" subtitle="Te damos la bienvenida al panel de control académico" icon="tabler:layout-dashboard" color="indigo" :actionsOnBottomOnMobile="false">
                <template #actions>
                    <Buttons label="Necesitas ayuda" icon="tabler:help" size="vuexy" color="red" :href="route('help')" hideLabelOnMobile />
                </template>
            </PremiumPageHeader>
        </template>

        <!-- Body -->
        <div>
            <!-- Slide reubicar -->
            <div class="container pb-4" v-if="confGlobal.value.INICIO_SHOW_SLIDE == '1'">
                <div class="col-span-1 lg:col-span-4 2xl:col-span-4 shadow-lg border" v-if="confGlobal.value.INICIO_SHOW_SLIDE == '1'">
                    <Splide :options="{ rewind: true, perPage: 1, type: 'loop', autoplay: 'true', pagination: boolean = false, arrows: boolean = false, gap: '1em' }" class="rounded-lg">
                        <div class="splide__arrows"></div>
                        <SplideSlide class="rounded-lg">
                            <div class="bg-[url('/img/dashboard/slider-01.png')] bg-no-repeat bg-center bg-cover rounded-lg">
                                <div class="rounded-lg bg-black/10" style="height: 385px"><!-- -+ bg-black/30-->
                                    <div class="md:w-1/2 py-20 lg:py-24 md:pl-24 px-10 object-fill text-white">
                                        <!-- <p class="font-bold text-sm uppercase">Vacaciones</p>
                                <p class="text-3xl font-bold">Talleres</p>
                                <p class="text-2xl mb-10 leading-none">Programas académicos y de aprendizaje por
                                    inicio de vacaciones.</p> -->
                                        <!-- <a href="#" class="btn btn-lg btn-rose mt-12">Eventos</a> --><!-- + mt-12 -->
                                    </div>
                                </div>

                            </div>
                        </SplideSlide>
                        <SplideSlide class="rounded-lg">
                            <div class="bg-[url('/img/dashboard/slider-02.png')] bg-no-repeat bg-center bg-cover rounded-lg">
                                <div class="rounded-lg bg-black/10" style="height: 385px"><!-- -+ bg-black/30-->
                                    <div class="md:w-1/2 py-20 lg:py-24 md:pl-24 px-10 object-fill text-white">
                                        <!-- <p class="font-bold text-sm uppercase">Se acaba el año</p>
                                <p class="text-3xl font-bold">Matriculas 2023</p>
                                <p class="text-2xl mb-10 leading-none">Realiza todas tus consultas por
                                    cualquiera de nuestros medios.</p> -->
                                        <!-- <a href="#" class="btn btn-lg btn-rose mt-12">Eventos</a> --><!-- + mt-12 -->
                                    </div>
                                </div>
                            </div>
                        </SplideSlide>

                    </Splide>
                </div>
            </div>
            <!-- ... -->

            <!--Alertas : maestro tutor apoderado estudiante diseño otros -->
            <div class="pb-4" v-if="$page.props.auth.user.id_rol <= 6">
                <AdminAlertsCard
                    :close-califications="arrayAlertCloseCalifications"
                    :publish-califications="arrayAlertPublishCalifications"
                    :show-califications="arrayAlertShowCalifications"
                    :loading="loadingAdminAlerts"
                    :error="errorAdminAlerts"
                    @reload="loadAdminAlerts"
                />
            </div>

            <!--Marcadores -->
            <div class=" pb-4">
                <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
                    <div class="lg:col-span-4 card-premium mb-0">
                        <div class="mb-4 flex justify-between items-center border-b border-slate-100 dark:border-slate-800 pb-4">
                            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">Marcadores</h3>
                           
                            <Buttons :href="route('config-mark')" label="Ver Lista" size="vuexy" icon="material-symbols:star" color="blue"/>
                        </div>

                        <div class="grid lg:grid-cols-4 md:grid-cols-2 md:gap-4 gap-3">
                            <!-- Escritorio de Estudiante o apoderado-->
                            <template v-if="$page.props.auth.user.rol_type == 'estudiante' || $page.props.auth.user.rol_type == 'apoderado'">
                                <template v-if="$page.props.auth.user.has_classroom">
                                    <div class="flex items-star justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                        <Link :href="route('student-courses')">
                                            <div class="flex gap-3">
                                                <div>
                                                    <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-red-500 focus:shadow-outline hover:bg-red-700">
                                                        <BaseIcon :path="mdiBook" :size="24" />
                                                    </div>
                                                </div>

                                                <div>
                                                    <h3 class="font-semibold text-base">Mis cursos</h3>
                                                    <p class="text-sm">Revisa tus guías, tareas y otros</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>

                                    <div class="flex items-start justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                        <Link :href="route('student-courses')">
                                            <div class="flex gap-3">
                                                <div>
                                                    <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-lime-500 focus:shadow-outline hover:bg-lime-700">
                                                        <BaseIcon :path="mdiCalendarCheckOutline" :size="28" />
                                                    </div>
                                                </div>

                                                <div>
                                                    <h3 class="font-semibold text-base">Mis tareas ({{ countTareaWithOutResp }})</h3>
                                                    <p class="text-sm"> Pendientes de entrega</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div class="flex items-start justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">

                                        <div class="flex gap-3">
                                            <div>
                                                <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-sky-500 focus:shadow-outline hover:bg-sky-700">
                                                    <BaseIcon :path="mdiClockTimeThreeOutline" :size="28" />
                                                </div>
                                            </div>

                                            <div>
                                                <h3 class="font-semibold text-base">Asistencia de hoy</h3>
                                                <p class="text-sm">{{ asistenciaHoy }}</p>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="flex items-start justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">

                                        <div class="flex gap-3">
                                            <div>
                                                <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-slate-500 focus:shadow-outline hover:bg-slate-700">
                                                    <BaseIcon :path="mdiAccountStar" :size="28" />
                                                </div>
                                            </div>

                                            <div>
                                                <h3 class="font-semibold text-base">Conducta semanal</h3>
                                                <p class="text-sm">{{ conductaSemanal }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div @click="openStudentHorarioModal" class="flex items-start justify-between rounded-md p-2 hover:bg-indigo-50 dark:hover:bg-indigo-950/20 cursor-pointer user-select border border-transparent hover:border-indigo-200 transition">
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-indigo-600 focus:shadow-outline hover:bg-indigo-700 shadow-sm">
                                                <BaseIcon :path="mdiCalendarRangeOutline" :size="28" />
                                            </div>
                                        </div>

                                        <div>
                                            <h3 class="font-semibold text-base text-slate-800 dark:text-slate-100">Mi Horario</h3>
                                            <p class="text-sm text-slate-500 dark:text-slate-400">Horario de clases semanal</p>
                                        </div>
                                    </div>
                                </div>
                                <div @click="openStudentAgendaModal" class="flex items-start justify-between rounded-md p-2 hover:bg-yellow-50 dark:hover:bg-yellow-950/20 cursor-pointer user-select border border-transparent hover:border-yellow-200 transition">
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-yellow-500 focus:shadow-outline hover:bg-yellow-600 shadow-sm">
                                                <BaseIcon :path="mdiCalendarAccount" :size="28" />
                                            </div>
                                        </div>

                                        <div>
                                            <h3 class="font-semibold text-base text-slate-800 dark:text-slate-100">Mi Agenda</h3>
                                            <p class="text-sm text-slate-500 dark:text-slate-400">Agenda diaria de temas, tareas y observaciones</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- Record de pagos -->
                                <!-- <div class="flex items-start justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('student-agenda')">
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-emerald-500 focus:shadow-outline hover:bg-emerald-700">
                                                <BaseIcon :path="mdiCashFast" :size="28" />
                                            </div>
                                        </div>

                                        <div>
                                            <h3 class="font-semibold text-base">Record de Pagos</h3>
                                            <p class="text-sm">Super super mala</p>
                                        </div>
                                    </div>
                                    </Link>
                                </div> -->
                                <!-- El estudiante que no paga no tiene acceso al sistema -->
                                <div v-if="publicarLibreta" class="flex items-start justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('calification-libreta')" target="_blank">
                                        <div class="flex gap-3">
                                            <div>
                                                <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-purple-500 focus:shadow-outline hover:bg-purple-700">
                                                    <BaseIcon :path="mdiFileDocument" :size="28" />
                                                </div>
                                            </div>

                                            <div>
                                                <h3 class="font-semibold text-base">Libreta de Notas</h3>
                                                <p class="text-sm">Vista previa</p>
                                                <span v-if="rangoLibreta" class="text-xs text-gray-500 dark:text-gray-400 font-medium block mt-0.5">{{ rangoLibreta }}</span>
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                            </template>
                            <!-- Diseñadora -->
                            <template v-else-if="$page.props.auth.user.rol_type == 'diseño'">
                                <div class="flex items-star justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('file-listado', { 'type': 'file_guideforcourse' })">
                                        <div class="flex gap-3">
                                            <div>
                                                <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-red-500 focus:shadow-outline hover:bg-red-700">
                                                    <BaseIcon :path="mdiBookOpenVariant" :size="24" />
                                                </div>
                                            </div>

                                            <div>
                                                <h3 class="font-semibold text-base">Guías de estudio</h3>
                                                <p class="text-sm">Asignado a los cursos</p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </template>
                            <!-- Maestros -->
                            <template v-else-if="$page.props.auth.user.rol_type == 'maestro' || $page.props.auth.user.rol_type == 'tutor'">
                                <div class="flex items-star justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('classrooms-collaborator')">
                                        <div class="flex gap-3">
                                            <div>
                                                <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-red-500 focus:shadow-outline hover:bg-red-700">
                                                    <BaseIcon :path="mdiGoogleClassroom" :size="24" />
                                                </div>
                                            </div>

                                            <div>
                                                <h3 class="font-semibold text-base">Mis aulas</h3>
                                                <p class="text-sm">Revisa tus aulas, alumnos y otros</p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </template>
                            <!-- Psdicología-->
                            <template v-else-if="$page.props.auth.user.id_rol == 12">
                                <div class="flex items-star justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('classrooms-collaborator')">
                                        <div class="flex gap-3">
                                            <div>
                                                <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-red-500 focus:shadow-outline hover:bg-red-700">
                                                    <BaseIcon :path="mdiGoogleClassroom" :size="24" />
                                                </div>
                                            </div>

                                            <div>
                                                <h3 class="font-semibold text-base">Mis aulas</h3>
                                                <p class="text-sm">Revisa aulas, alumnos y otros</p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </template>
                            <!-- Coordinador -->
                            <template v-else-if="$page.props.auth.user.rol_type == 'coordinador'">
                                <div class="flex items-star justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('classrooms-collaborator')">
                                        <div class="flex gap-3">
                                            <div>
                                                <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-red-500 focus:shadow-outline hover:bg-red-700">
                                                    <BaseIcon :path="mdiGoogleClassroom" :size="24" />
                                                </div>
                                            </div>

                                            <div>
                                                <h3 class="font-semibold text-base">Mis aulas</h3>
                                                <p class="text-sm">Revise sus aulas asignadas</p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </template>
                            <!-- Administradores -->
                            <template v-else>
                                <Link :href="route('areaFinanciera', { 'action': 'view_estados_cuenta' })">
                                    <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                        <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-yellow-500 rounded-lg focus:shadow-outline hover:bg-yellow-700">
                                            <BaseIcon :path="mdiStarOutline" :size="28" />
                                        </button>
                                        <div class="grid content-between h-11">
                                            <p class="text-sm font-semibold">Estados de cuenta</p>
                                            <div class="text-sm">
                                                Listado
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </template>

                            <!-- Iteración de marcadores -->
                            <!-- <div v-if="arrayMarks.length" v-for="obj in arrayMarks" :key="obj.id" class="flex items-star justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select"> -->

                            <div v-if="arrayMarks.length" v-for="obj in arrayMarks" :key="obj.id">
                                <a v-if="obj.target" :href="obj.url" target="_blank">
                                    <div class="flex items-center space-x-3 hover:bg-gray-100 rounded-md p-1">
                                        <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150  rounded-lg focus:shadow-outline" :class="'bg-' + obj.color + '-500 hover:bg-' + obj.color + '-700'">
                                            <BaseIcon :path="mdiStarShootingOutline" :size="28" />
                                        </button>
                                        <div class="grid content-between h-11">
                                            <p class="text-sm font-semibold">{{ obj.label }}</p>
                                            <div class="text-sm">
                                                {{ obj.description }}
                                            </div>
                                        </div>
                                    </div>
                                </a>

                                <Link v-else :href="obj.url">
                                    <div class="flex items-center space-x-3 hover:bg-gray-100 rounded-md p-1">
                                        <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 rounded-lg focus:shadow-outline" :class="'bg-' + obj.color + '-500 hover:bg-' + obj.color + '-700'">
                                            <BaseIcon :path="mdiStarOutline" :size="28" />
                                        </button>
                                        <div class="grid content-between h-11">
                                            <p class="text-sm font-semibold">{{ obj.label }}</p>
                                            <div class="text-sm">
                                                {{ obj.description }}
                                            </div>
                                        </div>
                                    </div>
                                </Link>


                                <!-- <Link v-else :href="obj.url">
                                <div class="flex gap-3">
                                    <div>
                                        <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 focus:shadow-outline" :class="'bg-' + obj.color + '-500 hover:bg-' + obj.color + '-700'">
                                            <BaseIcon :path="mdiStarOutline" :size="24" />
                                        </div>
                                    </div>
                                    <div>
                                        <h3 class="font-semibold text-base">{{ obj.label }}</h3>
                                        <p class="text-sm">{{ obj.description }}</p>
                                    </div>
                                </div>
                                </Link> -->

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Widget Resultados de Exámenes (Estudiante / Apoderado) - Imagen 5 -->
            <div v-if="($page.props.auth.user.rol_type == 'estudiante' || $page.props.auth.user.rol_type == 'apoderado') && $page.props.auth.user.has_classroom" class="pb-4">
                <div class="card-premium mb-0">
                    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 border-b border-slate-100 dark:border-slate-800 pb-3 mb-4">
                        <div class="flex items-center gap-2.5">
                            <div class="w-9 h-9 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center">
                                <BaseIcon :path="mdiChartBar" :size="22" />
                            </div>
                            <div>
                                <h3 class="font-bold text-base text-slate-800 dark:text-slate-100 leading-tight">
                                    Rendimiento en Exámenes
                                </h3>
                                <p class="text-xs text-slate-400">Resultados ordenados de menor a mayor calificación</p>
                            </div>
                        </div>

                        <!-- Selector de Bimestre -->
                        <div class="flex items-center gap-2">
                            <select
                                v-model="studentExamSelectedCiclo"
                                @change="loadStudentExamRanking(studentExamSelectedCiclo)"
                                class="text-xs rounded-xl border-slate-200 py-1.5 px-3 focus:ring-indigo-500 focus:border-indigo-500 bg-slate-50 font-medium"
                            >
                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1'">Primer Bimestre</option>
                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2'">Segundo Bimestre</option>
                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3'">Tercer Bimestre</option>
                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4'">Cuarto Bimestre</option>
                            </select>
                        </div>
                    </div>

                    <div v-if="studentExamRankingLoading" class="py-12 text-center text-slate-400 text-xs flex items-center justify-center gap-2">
                        <span class="animate-spin text-indigo-600 text-base">●</span>
                        <span>Cargando resultados de exámenes...</span>
                    </div>
                    <div v-else-if="!studentExamRankingData?.is_published" class="py-8 text-center bg-slate-50/50 rounded-xl border border-dashed border-slate-200">
                        <BaseIcon :path="mdiAlertCircle" :size="28" class="text-amber-500 mx-auto mb-2" />
                        <p class="text-sm font-semibold text-slate-700">Aún no se publican las notas de este periodo</p>
                        <p class="text-xs text-slate-400 mt-1">Las calificaciones de exámenes se mostrarán aquí una vez que sean publicadas por coordinación.</p>
                    </div>
                    <div v-else-if="studentExamRankingData?.chart_data && studentExamRankingData.chart_data.labels && studentExamRankingData.chart_data.labels.length" class="space-y-4">
                        <div class="h-64 sm:h-72 w-full">
                            <BarChart :data="studentExamRankingData.chart_data" :showLegend="true" yTitle="Nota" xTitle="Cursos (Menor a Mayor)" />
                        </div>

                        <!-- Resumen por curso ordenado de menor a mayor -->
                        <div v-if="confGlobal.value.STUDENT_CALIFICATION_SHOW_PROMEDIO == '1'" class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 pt-2 border-t border-slate-100">
                            <div
                                v-for="item in studentExamRankingData.courses"
                                :key="item.id_course"
                                class="p-2.5 rounded-xl border bg-white text-xs shadow-2xs"
                                :class="item.promedio_examenes < 11 ? 'border-rose-200 bg-rose-50/30' : 'border-slate-100'"
                            >
                                <div class="font-bold truncate text-slate-800" :title="item.course_name">{{ item.course_name }}</div>
                                <div class="flex items-center justify-between mt-1 text-[11px]">
                                    <span class="text-slate-400">Prom:</span>
                                    <span :class="item.promedio_examenes < 11 ? 'text-rose-600 font-bold' : 'text-indigo-600 font-bold'">
                                        {{ item.promedio_examenes }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="py-8 text-center text-slate-400 text-xs">
                        No se encontraron registros de exámenes para este periodo.
                    </div>
                </div>
            </div>

            <!-- Contenidos -->
            <div class="">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">
                    <!-- ESTUDIANTES -->
                    <template v-if="$page.props.auth.user.rol_type == 'estudiante' || $page.props.auth.user.rol_type == 'apoderado'">

                        <!-- LEFT: 3 WIDGETS ESTUDIANTILES INDEPENDIENTES -->
                        <div class="col-span-1 space-y-4">
                            <!-- WIDGET 1: SIMULACRO TIPO EXAMEN DE ADMISIÓN -->
                            <div v-if="haveEAP" class="bg-white dark:bg-slate-900 rounded-2xl border border-gray-100 dark:border-slate-800 shadow-sm p-5 hover:shadow-md transition">
                                <div class="flex items-center gap-3 mb-4 pb-3 border-b border-gray-100 dark:border-slate-800">
                                    <div class="w-10 h-10 rounded-xl bg-amber-50 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 flex items-center justify-center shrink-0">
                                        <Icon icon="tabler:certificate" class="w-5 h-5" />
                                    </div>
                                    <div>
                                        <h3 class="text-base font-bold text-gray-900 dark:text-white">Simulacro tipo examen de admisión</h3>
                                        <p class="text-xs text-gray-500 dark:text-gray-400">Puntajes y resultados de simulacros</p>
                                    </div>
                                </div>

                                <div v-if="arrayAdmisionPuntaje.length" class="space-y-2.5">
                                    <div v-for="client in arrayAdmisionPuntaje" :key="client.id" class="flex flex-col sm:flex-row sm:items-center justify-between gap-2 bg-gray-50 dark:bg-slate-800/60 p-3 rounded-xl border border-gray-100 dark:border-slate-800">
                                        <div class="flex flex-wrap items-center gap-2">
                                            <span class="text-xs font-semibold text-gray-700 dark:text-gray-300">{{ client.ref_ciclo }}</span>
                                            <span class="text-sm font-bold text-gray-900 dark:text-white">{{ client.label_eap }}</span>
                                            <span class="px-2 py-0.5 bg-indigo-50 text-indigo-700 dark:bg-indigo-950/40 dark:text-indigo-300 rounded-lg text-xs font-bold">
                                                {{ client.puntaje }} pts
                                            </span>
                                            <span v-if="client.resultado == '1'" class="px-2 py-0.5 rounded-full text-xs font-bold bg-emerald-500 text-white">
                                                Ingresó
                                            </span>
                                            <span v-else-if="client.resultado == '2'" class="px-2 py-0.5 rounded-full text-xs font-bold bg-amber-500 text-white">
                                                Ausente
                                            </span>
                                            <span v-else class="px-2 py-0.5 rounded-full text-xs font-bold bg-rose-500 text-white">
                                                No ingresó
                                            </span>
                                        </div>
                                        <BaseButtons v-if="confGlobal.value.INICIO_STUDENT_SHOW_PRINT_DIPLOMA == '1'" no-wrap>
                                            <BaseButton color="info" :icon="mdiPrinter" small :href="'/admisionpuntaje/diploma?id=' + client.id" target="_blank" />
                                        </BaseButtons>
                                    </div>
                                </div>
                                <div v-else class="bg-gray-50 dark:bg-slate-800/60 p-4 rounded-xl text-center text-sm text-gray-500 dark:text-gray-400 border border-gray-100 dark:border-slate-800">
                                    Aun no se publica el puntaje …
                                </div>
                            </div>

                            <!-- WIDGET 2: DOCUMENTOS DE NIVEL -->
                            <StudentDocumentsCard
                                :files="filesForLevel"
                                :loading="loadingFilesForLevel"
                                :error="errorFilesForLevel"
                                @preview="openStudentPreview"
                                @reload="listarFilesForLevel"
                            />

                            <!-- WIDGET 3: COMUNICADOS INSTITUCIONALES -->
                            <StudentComunicadosCard
                                :comunicados="comunicadosList"
                                :loading="loadingComunicados"
                                :error="errorComunicados"
                                @openDetail="openComunicadoDetail"
                                @reload="loadActiveComunicados"
                            />
                        </div>

                        <!-- Agenda diaria -->
                        <!-- <div class="col-span-1 lg:col-span-2 2xl:col-span-5 rounded-lg overflow-hidden shadow-lg border bg-white h-full lg:pb-6">
                            <div class="w-full pt-6 px-6">
                                <h1 class="text-gray-900 text-xl font-bold mb-4">Agenda de Tareas del dia</h1>
                            </div>
                            <div class="min-h-[280px] h-[calc(100%-68px)] p-0 lg:px-6 overflow-x-auto">
                                <div class="table w-full h-full min-w-[550px] overflow-x-auto">
                                    <div class="table-header-group h-10">
                                        <div class="table-row bg-gray-700 text-white gap-2 text-sm lg:text-base">
                                            <div class="table-cell text-center align-middle lg:rounded-tl-md">Curso</div>
                                            <div class="table-cell text-center align-middle">Tema</div>
                                            <div class="table-cell text-center align-middle lg:rounded-tr-md">Tarea
                                            </div>
                                        </div>
                                    </div>
                                    <div class="table-row-group">
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle border-b border-r border-l">Ingles</div>
                                            <div class="table-cell align-middle border-b border-r">Lorem ipsum dolor sit amet.</div>
                                            <div class="table-cell align-middle border-b border-r">Lorem, ipsum.</div>
                                        </div>
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle border-b border-r border-l">Algebra</div>
                                            <div class="table-cell align-middle border-b border-r">Lorem ipsum dolor sit amet.</div>
                                            <div class="table-cell align-middle border-b border-r " id="12active">Lorem, ipsum.
                                            </div>
                                        </div>
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle border-b border-r border-l">Aptitud Verbal</div>
                                            <div class="table-cell align-middle border-b border-r">Lorem ipsum dolor sit amet.</div>
                                            <div class="table-cell align-middle border-b border-r">Lorem, ipsum.</div>
                                        </div>
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle border-b border-r border-l">Ciencia</div>
                                            <div class="table-cell align-middle border-b border-r">Lorem ipsum dolor sit amet.</div>
                                            <div class="table-cell align-middle border-b border-r">Lorem, ipsum.</div>
                                        </div>
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle border-b border-r border-l rounded-bl-md">Lenguaje
                                            </div>
                                            <div class="table-cell align-middle border-b border-r">Lorem ipsum dolor sit amet.</div>
                                            <div class="table-cell align-middle rounded-br-md border-b border-r">Lorem, ipsum.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div> -->
                        <!-- Rol de exámenes -->
                        <!-- <div class="col-span-1 lg:col-span-2 2xl:col-span-4 rounded-lg overflow-hidden shadow-lg border bg-white h-full lg:pb-6">
                            <div class="w-full pt-6 px-6">
                                <h1 class="text-gray-900 text-xl font-bold mb-4">Roles de Examenes</h1>

                            </div>
                            <div class="min-h-[280px] h-[calc(100%-68px)] p-0 lg:px-6 overflow-x-auto">
                                <div class="table w-full h-full min-w-[550px] overflow-x-auto">
                                    <div class="table-header-group h-10">
                                        <div class="table-row bg-gray-700 text-white gap-2 text-sm lg:text-base">
                                            <div class="table-cell text-center align-middle lg:rounded-tl-md">Fecha</div>
                                            <div class="table-cell text-center align-middle">Curso</div>
                                            <div class="table-cell text-center align-middle lg:rounded-tr-md">Observación
                                            </div>
                                        </div>
                                    </div>
                                    <div class="table-row-group">
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle border-b border-r border-l">Lunes 07/10</div>
                                            <div class="table-cell align-middle border-b border-r">
                                                <div class="flex flex-row items-center w-full h-full">
                                                    <div class="w-1/2 border-r">Matematica</div>
                                                    <div class="w-1/2">Ingles</div>
                                                </div>
                                            </div>
                                            <div class="table-cell align-middle border-b border-r">Estudia infeliz</div>
                                        </div>
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle border-b border-r border-l">Martes 08/10</div>
                                            <div class="table-cell align-middle border-b border-r">
                                                <div class="flex flex-row items-center w-full h-full">
                                                    <div class="w-full">
                                                        Algebra
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="table-cell align-middle border-b border-r " id="12active">Lorem, ipsum.
                                            </div>
                                        </div>
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle border-b border-r border-l">Miercoles 09/10</div>
                                            <div class="table-cell align-middle border-b border-r">
                                                <div class="flex flex-row items-center w-full h-full">
                                                    <div class="w-full">
                                                        Aritmetica
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="table-cell align-middle border-b border-r">Lorem, ipsum.</div>
                                        </div>
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle border-b border-r border-l">Jueves 10/10</div>
                                            <div class="table-cell align-middle border-b border-r">
                                                <div class="flex flex-row items-center w-full h-full">
                                                    <div class="w-1/2 border-r">Ciencia</div>
                                                    <div class="w-1/2">Biologia</div>
                                                </div>
                                            </div>
                                            <div class="table-cell align-middle border-b border-r">Lorem, ipsum.</div>
                                        </div>
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle border-b border-r border-l rounded-bl-md">Viernes 11/10
                                            </div>
                                            <div class="table-cell align-middle border-b border-r">Historia</div>
                                            <div class="table-cell align-middle rounded-br-md border-b border-r">Lorem, ipsum.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <!-- RIGHT -->
                        <div v-if="$page.props.auth.user.has_classroom" class="col-span-1">
                            <div class="grid grid-cols-1 gap-4">
                                <div class="col-span-1 lg:col-span-2 2xl:col-span-4 card-premium">
                                    <SectionTitleLineWithButtonUnens title="Gráfica de competencias">
                                        <!-- <BaseButton :icon="mdiReload" color="whiteDark" @click="fillChartData" /> -->
                                        <select v-model="chartSelectCiclo" @change="listarChartCalification(chartSelectCiclo)">
                                            <option value="" disabled>Escoja el Bimestre</option>
                                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1'" selected>Primer Bimestre</option>
                                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2'" selected>Segundo Bimestre</option>
                                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3'" selected>Tercer Bimestre</option>
                                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4'" selected>Cuarto Bimestre</option>
                                        </select>
                                    </SectionTitleLineWithButtonUnens>
                                    <CardBox class="p-0 overflow-hidden">
                                        <div v-if="publicarNotas && chartCalifications" class="p-3">
                                            <CompetencyGraphic :data="chartCalifications" heightClass="h-[360px]" />
                                        </div>
                                        <div v-else class="py-16 px-6 text-center bg-slate-50/50">
                                            <BaseIcon :path="mdiAlertCircle" :size="32" class="text-amber-500 mx-auto mb-2" />
                                            <p class="text-sm font-semibold text-slate-700">Aún no se publican las calificaciones</p>
                                            <p class="text-xs text-slate-400 mt-1 max-w-xs mx-auto">
                                                La gráfica de competencias se visualizará cuando las calificaciones de este periodo se encuentren publicadas.
                                            </p>
                                        </div>
                                    </CardBox>
                                </div>
                            </div>
                        </div>

                        <!-- Agenda de alumno Horario -->
                        <!-- <div class="rounded-lg overflow-hidden shadow-lg border bg-white h-full lg:pb-6">
                                <div class="w-full pt-6">
                                    <h1 class="text-gray-900 text-xl font-bold mb-4 text-center">Horario de Clases</h1>

                                </div>
                                <div class="min-h-[280px] h-[calc(100%-68px)] p-0 lg:px-6 overflow-x-auto">
                                    <div class="table w-full h-full min-w-[550px] overflow-x-auto">
                                        <div class="table-header-group h-10">
                                            <div class="table-row bg-gray-700 text-white gap-2 text-sm lg:text-base">
                                                <div class="table-cell text-center align-middle lg:rounded-tl-md">Hora</div>
                                                <div class="table-cell text-center align-middle">Lunes</div>
                                                <div class="table-cell text-center align-middle">Martes</div>
                                                <div class="table-cell text-center align-middle">Miercoles</div>
                                                <div class="table-cell text-center align-middle">Jueves</div>
                                                <div class="table-cell text-center align-middle lg:rounded-tr-md">Viernes
                                                </div>
                                            </div>
                                        </div>
                                        <div class="table-row-group">
                                            <div class="table-row text-center text-xs lg:text-sm">
                                                <div class="table-cell align-middle bg-gray-100">08:00 am</div>
                                                <div class="table-cell align-middle border-b border-r">Lenguaje </div>
                                                <div class="table-cell align-middle border-b border-r">Matematica</div>
                                                <div class="table-cell align-middle border-b border-r">Arte </div>
                                                <div class="table-cell align-middle border-b border-r">Etc</div>
                                                <div class="table-cell align-middle border-b border-r">Etc</div>
                                            </div>
                                            <div class="table-row text-center text-xs lg:text-sm">
                                                <div class="table-cell align-middle bg-gray-100">09:00 am</div>
                                                <div class="table-cell align-middle border-b border-r">Lenguaje </div>
                                                <div
                                                    class="table-cell align-middle border-b border-r bg-blue-600 text-white">
                                                    Matematica</div>
                                                <div class="table-cell align-middle border-b border-r">Arte </div>
                                                <div class="table-cell align-middle border-b border-r">Etc</div>
                                                <div class="table-cell align-middle border-b border-r " id="12active">Etc
                                                </div>
                                            </div>
                                            <div class="table-row text-center text-xs lg:text-sm">
                                                <div class="table-cell align-middle bg-gray-100">10:00 am</div>
                                                <div class="table-cell align-middle border-b border-r">Recreo </div>
                                                <div class="table-cell align-middle border-b border-r">Recreo</div>
                                                <div class="table-cell align-middle border-b border-r">Recreo</div>
                                                <div class="table-cell align-middle border-b border-r">Recreo</div>
                                                <div class="table-cell align-middle border-b border-r">Recreo</div>
                                            </div>
                                            <div class="table-row text-center text-xs lg:text-sm">
                                                <div class="table-cell align-middle bg-gray-100">11:00 am</div>
                                                <div class="table-cell align-middle border-b border-r">Lenguaje </div>
                                                <div class="table-cell align-middle border-b border-r">Matematica</div>
                                                <div class="table-cell align-middle border-b border-r">Arte </div>
                                                <div class="table-cell align-middle border-b border-r">Etc</div>
                                                <div class="table-cell align-middle border-b border-r">Etc</div>
                                            </div>
                                            <div class="table-row text-center text-xs lg:text-sm">
                                                <div class="table-cell align-middle bg-gray-100 rounded-bl-md">12:00 am
                                                </div>
                                                <div class="table-cell align-middle border-b border-r">Lenguaje </div>
                                                <div class="table-cell align-middle border-b border-r">Matematica</div>
                                                <div class="table-cell align-middle border-b border-r">Arte </div>
                                                <div class="table-cell align-middle border-b border-r">Etc</div>
                                                <div class="table-cell align-middle rounded-br-md border-b border-r">Etc
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div> -->
                    </template>

                    <!-- PORTERO -->
                    <template v-else-if="$page.props.auth.user.rol_type == 'portero'">
                        <div class="col-span-1 lg:col-span-4 2xl:col-span-4 card-premium">
                            <div class="flex justify-center">
                                <div class="card-premium md:min-h-[385px] w-full lg:w-3/4">

                                    <div class="text-center">
                                        <h5 class="text-gray-900 text-xl font-bold mb-5">Registro de Asistencia</h5>
                                    </div>
                                    <div>
                                        <div class="flex items-center w-full h-[275px]">
                                            <div class="grid grid-cols-2 gap-4 text-center w-full">
                                                <input class="col-span-2 border border-gray-200 rounded-md p-3 text-center [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" type="number" placeholder="Ingresar ID" required>

                                                <div class="col-span-2 md:col-span-1 lg:col-span-1 flex flex-row border border-gray-200 hover:bg-gray-200 hover:border-gray-300 rounded-md  items-center">
                                                    <label for="04" class="w-full p-4">
                                                        <div class="flex items-center">
                                                            <div>
                                                                <input type="radio" id="04" name="tardanza2">
                                                            </div>
                                                            <div class="w-full">Tardanza</div>
                                                            <div class="flex items-center">
                                                                <BaseIcon :path="mdiClockRemove" :size="24" :color="red" />
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                                <div class="col-span-2 md:col-span-1 lg:col-span-1 flex flex-row border border-gray-200 hover:bg-gray-200 hover:border-gray-300 rounded-md  items-center">
                                                    <label for="03" class="w-full p-4">
                                                        <div class="flex items-center">
                                                            <div>
                                                                <input type="radio" id="03" name="tardanza2">
                                                            </div>
                                                            <div class="w-full">Tardanza Justificada</div>
                                                            <div class="flex items-center">
                                                                <BaseIcon :path="mdiClockCheck" :size="24" />
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                                <div class="col-span-2">
                                                    <button class="btn btn-rose w-full p-4">
                                                        Enviar registro
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- Otros como maestro, tutor, coordinador, admin, secreraria -->
                    <template v-else>
                        <!-- LEFT -->
                        <div class="col-span-1">
                            <div class="grid grid-cols-1 gap-4">
                                <!-- info de asistencia -->
                                <div class="col-span-1" v-if="$page.props.auth.user.rol_type == 'maestro' || $page.props.auth.user.rol_type == 'tutor' || $page.props.auth.user.rol_type == 'coordinador' || $page.props.auth.user.rol_type == 'secretaria'">
                                    <div v-if="arrayAsistencia && arrayAsistencia.length" class="card-premium h-full flex items-center w-full">
                                        <div v-for="asistencia in arrayAsistencia" class="w-full">
                                            <div class="w-full" title="Información mostrada hasta donde el responsable de asistencia haya cargado las marcaciones">
                                                <small class="text-gray-900 font-bold mb-4 text-left">
                                                    Asistencia {{ asistencia.name }}
                                                </small>
                                                <!-- <p class="text-gray-700 text-base mb-4">
                                        Precisemos la asistencia de los alumnos.
                                    </p> -->
                                            </div>
                                            <div class="w-full">
                                                <div class="grid grid-cols-6 rounded-md mb-4 p-2 hover:bg-gray-50 border" :title="(asistencia.records.justificada ? 'Justificadas: ' + asistencia.records.justificada + ' \n Fechas: ' + asistencia.records.justificadadet : '')">
                                                    <div class="flex items-center">
                                                        <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-green-600 bg-green-100">
                                                            <BaseIcon :path="mdiCheckBold" :size="20" />
                                                        </div>

                                                    </div>
                                                    <div class="col-span-3">
                                                        <h6 class="text-base font-bold mb-2"> Normal</h6>
                                                        <div class="w-full bg-gray-200 rounded-full h-1.5 ">
                                                            <div class="bg-green-500 h-1.5 rounded-full" :style="'width: ' + (asistencia.records.asistencia * 100 / asistencia.records.diaslaborales) + '%'">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-span-2">
                                                        <div class="flex items-center justify-end h-full">
                                                            <div class="flex items-center p-1 border border-gray-300 rounded">
                                                                <span class="text-sm">{{ asistencia.records.asistencia }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="grid grid-cols-6 rounded-md mb-4 p-2 hover:bg-gray-50 border" :title="(asistencia.records.faltas ? 'Fechas: ' + asistencia.records.faltadet : '')">
                                                    <div class="flex items-center">
                                                        <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-red-600 bg-red-100">
                                                            <BaseIcon :path="mdiCloseThick" :size="20" />
                                                        </div>

                                                    </div>
                                                    <div class="col-span-3">
                                                        <h6 class="text-base font-bold mb-2"> Faltas</h6>
                                                        <div class="w-full bg-gray-200 rounded-full h-1.5">
                                                            <div class="bg-red-500 h-1.5 rounded-full" :style="'width: ' + (asistencia.records.faltas * 100 / asistencia.records.diaslaborales) + '%'">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-span-2">
                                                        <div class="flex items-center justify-end h-full">
                                                            <div class="flex items-center p-1 border border-gray-300 rounded">
                                                                <span class="text-sm">{{ asistencia.records.faltas }}</span><!-- 23 -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="grid grid-cols-6 rounded-md mb-4 p-2 hover:bg-gray-50 border">
                                                    <div class="flex items-center">
                                                        <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-yellow-600 bg-yellow-100">
                                                            <BaseIcon :path="mdiMinusThick" :size="20" />
                                                        </div>

                                                    </div>
                                                    <div class="col-span-3">
                                                        <h6 class="text-base font-bold mb-2"> Tardanza</h6>
                                                        <div class="w-full bg-gray-200 rounded-full h-1.5 ">
                                                            <div class="bg-yellow-400 h-1.5 rounded-full" :style="'width: ' + (asistencia.records.tardanzas * 100 / asistencia.records.diaslaborales) + '%'">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-span-2">
                                                        <div class="flex items-center justify-end h-full">
                                                            <div class="flex items-center p-1 border border-gray-300 rounded">
                                                                <span class="text-sm">{{ asistencia.records.tardanzas }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="grid grid-cols-6 rounded-md mb-4 p-2 hover:bg-gray-50 border">
                                                    <div class="flex items-center">
                                                        <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-sky-600 bg-sky-100">
                                                            <BaseIcon :path="mdiChevronRight" :size="20" />
                                                        </div>

                                                    </div>
                                                    <div class="col-span-3">
                                                        <h6 class="text-base font-bold mb-2"> Sal. Temp.</h6>
                                                        <div class="w-full bg-gray-200 rounded-full h-1.5 ">
                                                            <div class="bg-sky-400 h-1.5 rounded-full" :style="'width: ' + (asistencia.records.salidas_temprano * 100 / asistencia.records.diaslaborales) + '%'">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-span-2">
                                                        <div class="flex items-center justify-end h-full">
                                                            <div class="flex items-center p-1 border border-gray-300 rounded">
                                                                <span class="text-sm">{{ asistencia.records.salidas_temprano }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="card-premium h-full flex items-center w-full">
                                        <div class="w-full">
                                            <div class="w-full">
                                                <h3 class="text-gray-900 text-xl font-bold mb-4 text-left">
                                                    Asistencia
                                                </h3>
                                                <!-- <p class="text-gray-700 text-base mb-4">
                                        Precisemos la asistencia de los alumnos.
                                    </p> -->
                                            </div>
                                            <div class="w-full grid gap-4">
                                                <div class="flex justify-between rounded-md p-2 hover:bg-gray-50 border">
                                                    <div class="flex items-center">
                                                        <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-green-600 bg-green-100">
                                                            <BaseIcon :path="mdiCheckBold" :size="20" />
                                                        </div>

                                                    </div>
                                                    <div class="w-full mx-3">
                                                        <h6 class="text-base font-bold mb-2"> Normal</h6>
                                                        <div class="w-full bg-gray-200 rounded-full h-1.5 ">
                                                            <div class="bg-green-500 h-1.5 rounded-full" style="width: 0%">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="w-12 flex items-center rounded justify-center h-full p-1 border border-gray-300 ">
                                                            <span class="text-sm">0</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="flex justify-between rounded-md p-2 hover:bg-gray-50 border">
                                                    <div class="flex items-center">
                                                        <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-red-600 bg-red-100">
                                                            <BaseIcon :path="mdiCloseThick" :size="20" />
                                                        </div>

                                                    </div>
                                                    <div class="w-full mx-3">
                                                        <h6 class="text-base font-bold mb-2"> Faltas</h6>
                                                        <div class="w-full bg-gray-200 rounded-full h-1.5">
                                                            <div class="bg-red-500 h-1.5 rounded-full" :style="'width: ' + (cantFaltas * 100 / 23) + '%'">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="w-12 flex items-center rounded justify-center h-full p-1 border border-gray-300">
                                                            <span class="text-sm">{{ cantFaltas }}</span><!-- 23 -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="flex justify-between rounded-md p-2 hover:bg-gray-50 border">
                                                    <div class="flex items-center">
                                                        <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-yellow-600 bg-yellow-100">
                                                            <BaseIcon :path="mdiMinusThick" :size="20" />
                                                        </div>

                                                    </div>
                                                    <div class="w-full mx-3">
                                                        <h6 class="text-base font-bold mb-2"> Tardanza</h6>
                                                        <div class="w-full bg-gray-200 rounded-full h-1.5 ">
                                                            <div class="bg-yellow-400 h-1.5 rounded-full" :style="'width: ' + (cantTardanzas * 100 / 23) + '%'">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="w-12 flex items-center rounded justify-center h-full p-1 border border-gray-300">
                                                            <span class="text-sm">{{ cantTardanzas }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="flex justify-between rounded-md p-2 hover:bg-gray-50 border">
                                                    <div class="flex items-center">
                                                        <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-sky-600 bg-sky-100">
                                                            <BaseIcon :path="mdiChevronRight" :size="20" />
                                                        </div>

                                                    </div>
                                                    <div class="w-full mx-3">
                                                        <h6 class="text-base font-bold mb-2">Sal. Temp.</h6>
                                                        <div class="w-full bg-gray-200 rounded-full h-1.5 ">
                                                            <div class="bg-sky-400 h-1.5 rounded-full" :style="'width: ' + (cantTardanzas * 100 / 23) + '%'">
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div class="w-12 flex items-center rounded justify-center h-full p-1 border border-gray-300">
                                                            <span class="text-sm">{{ cantTardanzas }}</span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Estudiantes activos (Métricas Responsivas y Resilientes) -->
                                <div class="col-span-1" v-if="$page.props.auth.user.rol_type == 'coordinador' || $page.props.auth.user.rol_type == 'admin' || $page.props.auth.user.rol_type == 'secretaria'">
                                    <AdminMetricsGrid
                                        :actives="studentActives"
                                        :news="studentNews"
                                        :olds="studentOlds"
                                        :inactives="studentInactives"
                                        :total="studentTotal"
                                        :loading="loadingAdminMetrics"
                                        :error="errorAdminMetrics"
                                        @reload="contadorAlumnosActivos"
                                    />
                                </div>

                                <!-- Estado de disco Admin, AdminCoord o secretaria-->
                                <div class="col-span-1" v-if="$page.props.auth.user.id_rol <= 4 || $page.props.auth.user.rol_type == 'secretaria'">
                                    <AdminStorageCard
                                        :chart-data="chartStatusDisk"
                                        :loading="loadingStorageDisk"
                                        :error="errorStorageDisk"
                                        @reload="getChartStatusDisk"
                                    />
                                </div>
                            </div>
                        </div>

                        <!-- RIGHT -->
                        <div class="col-span-1">
                            <div class="grid grid-cols-1 gap-4">
                                <!-- Últimos estudiantes matriculados -->
                                <div class="col-span-1" v-if="$page.props.auth.user.rol_type == 'coordinador' || $page.props.auth.user.rol_type == 'admin' || $page.props.auth.user.rol_type == 'secretaria'">
                                    <div class="card-premium overflow-x-auto p-6">
                                        <div class="mb-4 flex justify-between items-center border-b border-slate-100 dark:border-slate-800 pb-2 px-2">
                                            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">Últimos 5 estudiantes creados</h3>
                                        </div>
                                        <table class="w-full table-basic mt-2">
                                            <tbody v-if="arrayLastStudents.length > 0">
                                                <tr v-for="item in arrayLastStudents">
                                                    <td scope="row">
                                                        <div class="tip-coment">

                                                            <Link :href="'/student/card?id=' + item.id" class="text-blue-600 hover:text-blue-800 hover:font-semibold transition-all ease-in-out delay-150 duration-150">
                                                                {{ item.apellidos }} {{ item.nombres }}
                                                            </Link>

                                                            <!-- <div class="tip-coment-content">
                                                                <h3>{{ item.apellidos }} {{ item.nombres }}</h3>
                                                                <span class="font-bold mr-2">DNI : </span>{{ item.num_doc }}
                                                                <br>
                                                                <span class="font-bold mr-2">Género : </span>{{ item.sexo ?
                                                                    'Masculino' :
                                                                    'Femenino'
                                                                }}<br>
                                                                <span class="font-bold mr-2">Matrícula : </span>{{ item.fecha_matricula }}
                                                                <br>
                                                                
                                                            </div> -->
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span :class="(item.label_level ? '' : 'text-red-600')" data-title="Nivel/Grado">
                                                            {{ (item.label_level ? item.label_level : 'Sin Nivel asignado') }}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span :class="(item.label_classroom ? '' : 'text-red-600')" data-title="Aula de estudio">
                                                            {{ (item.label_classroom ? item.label_classroom : 'Sin Aula asignado') }}
                                                        </span>
                                                    </td>
                                                    <td data-title="Fecha de creación">
                                                        {{ formatDateTime(item.created_at) }}
                                                    </td>
                                                    <!-- -LRR <td :title="(item.status == 0 ? 'Retirado' : (item.status == 1 ? 'Activo' : 'Pendiente'))"> -->
                                                    <td>
                                                        <div class="flex items-center justify-center">
                                                            <!-- -LRR <span :class="'inline-block p-2 bg-' + (item.status == 0 ? 'red' : (item.status == 1 ? 'green' : 'yellow')) + '-500 rounded-full'"></span> -->
                                                            <span :class="'inline-block p-2 bg-red-500 rounded-full'" v-if="item.status == 0" title="Retirado"></span>
                                                            <span :class="'inline-block p-2 bg-green-500 rounded-full'" v-else-if="item.status == 1" title="Activo"></span>
                                                            <span :class="'inline-block p-2 bg-yellow-500 rounded-full'" v-else-if="item.status == 2" title="Ingresante"></span>
                                                            <span :class="'inline-block p-2 bg-gray-500 rounded-full'" v-else-if="item.status == 3" title="Egresado"></span>
                                                            <span :class="'inline-block p-2 bg-yellow-500 rounded-full'" v-else-if="item.status == 4" title="Ingresante Vacacional"></span>
                                                            <span :class="'inline-block p-2 bg-yellow-500 rounded-full'" v-else-if="item.status == -1" title="Promovido"></span>
                                                            <span v-else></span>
                                                        </div>
                                                    </td>
                                                </tr>

                                            </tbody>
                                            <tbody v-else>
                                                <tr>
                                                    <td scope="row" class="px-6 py-4 ">
                                                        Sin resultados.
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Error PP -->
                        <div v-if="confGlobal.value.SHOW_ERROR_PP == 1 && $page.props.auth.user.id_rol == 1" class="col-span-1 lg:col-span-2 2xl:col-span-4 card-premium">
                            <h3 class="font-bold text-2xl md:text-6xl">ERROR PP 1301</h3>
                        </div>

                    </template>

                </div>
            </div>

        </div>

        <!-- Modal de Vista Previa Protegida para Estudiantes -->
        <Preview v-model="isStudentPreviewActive" :file="studentPreviewFile" :onlyread="true" />

        <!-- MODAL DE HORARIO Y AGENDA ESCOLAR DEL ESTUDIANTE -->
        <CardBoxModal v-model="isStudentAgendaModalOpen" :title="studentAgendaTab === 'horario' ? 'Mi Horario Semanal' : 'Mi Agenda Escolar'" sizeModal="large" no-buttons hasCancel>
            <div class="space-y-4">
                <!-- Selector de Pestaña: Agenda Diaria vs Horario Semanal -->
                <div class="flex items-center gap-2 border-b border-slate-200 dark:border-slate-800 pb-3">
                    <button @click="studentAgendaTab = 'agenda'" :class="studentAgendaTab === 'agenda' ? 'bg-rose-600 text-white shadow-xs' : 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300'" class="px-4 py-2 rounded-xl text-xs font-bold transition flex items-center gap-2">
                        <Icon icon="tabler:notebook" class="w-4 h-4" />
                        Agenda del Día
                    </button>
                    <button @click="studentAgendaTab = 'horario'" :class="studentAgendaTab === 'horario' ? 'bg-indigo-600 text-white shadow-xs' : 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300'" class="px-4 py-2 rounded-xl text-xs font-bold transition flex items-center gap-2">
                        <Icon icon="tabler:calendar-time" class="w-4 h-4" />
                        Horario Semanal
                    </button>
                </div>

                <!-- ESTADO DE CARGA -->
                <div v-if="studentAgendaLoading" class="py-12 text-center text-slate-400">
                    <Icon icon="svg-spinners:180-ring-with-bg" class="w-8 h-8 mx-auto mb-2 text-rose-500" />
                    <p class="text-xs font-semibold">Cargando información escolar...</p>
                </div>

                <!-- CONTENIDO CUANDO ESTÁ CARGADO -->
                <div v-else-if="studentAgendaData">
                    <!-- 1. VISTA AGENDA DEL DÍA (CUADERNO FÍSICO DIGITALIZADO) -->
                    <div v-if="studentAgendaTab === 'agenda'" class="space-y-4">
                        <!-- Navegación de Fecha y Cabecera del Cuaderno -->
                        <div class="p-3 bg-purple-50/50 dark:bg-purple-950/20 rounded-2xl border border-purple-200/60 dark:border-purple-900/40 flex items-center justify-between flex-wrap gap-2">
                            <div class="flex items-center gap-2">
                                <button @click="changeStudentAgendaDate(-1)" class="p-1.5 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 text-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-700 shadow-xs" title="Día anterior">
                                    <Icon icon="tabler:chevron-left" class="w-4 h-4" />
                                </button>
                                <button @click="studentAgendaDate = getLocalDateString(); loadStudentAgenda(studentAgendaDate);" class="px-2.5 py-1 bg-white dark:bg-slate-800 hover:bg-slate-100 text-slate-700 dark:text-slate-200 rounded-lg text-xs font-bold border border-slate-200 dark:border-slate-700 shadow-xs">
                                    Hoy
                                </button>
                                <button @click="changeStudentAgendaDate(1)" class="p-1.5 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 text-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-700 shadow-xs" title="Día siguiente">
                                    <Icon icon="tabler:chevron-right" class="w-4 h-4" />
                                </button>
                                <input type="date" :value="studentAgendaDate" @change="loadStudentAgenda($event.target.value); studentAgendaDate = $event.target.value;" class="text-xs font-bold rounded-lg border-slate-200 dark:border-slate-700 dark:bg-slate-800 px-2 py-1" />
                            </div>

                            <!-- Headers físicos -->
                            <div class="flex items-center gap-2 flex-wrap">
                                <span class="px-2.5 py-0.5 rounded-lg bg-rose-500/10 text-rose-600 font-extrabold text-xs border border-rose-500/20">
                                    DAY: {{ studentAgendaData.header.dayName }} {{ studentAgendaData.header.dayNumber }}
                                </span>
                                <span class="px-2.5 py-0.5 rounded-lg bg-indigo-500/10 text-indigo-600 font-extrabold text-xs border border-indigo-500/20">
                                    Month: {{ studentAgendaData.header.monthName }}
                                </span>
                                <span class="px-2.5 py-0.5 rounded-lg bg-amber-500/10 text-amber-600 font-extrabold text-xs border border-amber-500/20">
                                    Week: {{ studentAgendaData.header.weekNumber }}
                                </span>
                                <span class="px-2.5 py-0.5 rounded-lg bg-emerald-500/10 text-emerald-600 font-extrabold text-xs border border-emerald-500/20">
                                    Year: {{ studentAgendaData.header.year }}
                                </span>
                            </div>
                        </div>

                        <!-- Tabla General de Cursos y Tareas de Hoy -->
                        <div class="border border-purple-200 dark:border-purple-900/50 rounded-2xl overflow-hidden shadow-xs">
                            <table class="w-full text-left text-xs">
                                <thead class="bg-purple-50 dark:bg-purple-950/40 text-purple-900 dark:text-purple-300 font-extrabold uppercase border-b border-purple-200 dark:border-purple-900/50">
                                    <tr>
                                        <th class="py-2.5 px-3 w-10 text-center">#</th>
                                        <th class="py-2.5 px-3 w-1/4">SUBJECT</th>
                                        <th class="py-2.5 px-3 w-1/2">TOPICS</th>
                                        <th class="py-2.5 px-3 w-1/4 text-center">HOME WORKS</th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-purple-100 dark:divide-purple-950/40 bg-white dark:bg-slate-900">
                                    <tr v-for="(item, idx) in studentAgendaData.agendaItems" :key="idx" class="hover:bg-purple-50/20 transition">
                                        <td class="py-2 px-3 text-center font-bold text-slate-400">{{ idx + 1 }}</td>
                                        <td class="py-2 px-3 font-bold text-purple-950 dark:text-purple-200">{{ item.subject }}</td>
                                        <td class="py-2 px-3 text-slate-700 dark:text-slate-300">{{ item.topic || '—' }}</td>
                                        <td class="py-2 px-3 text-center">
                                            <span v-if="!item.has_homework" class="px-2 py-0.5 rounded-md bg-slate-100 dark:bg-slate-800 text-slate-500 font-extrabold text-[10px]">NO</span>
                                            <div v-else class="text-left">
                                                <span class="px-2 py-0.5 rounded-md bg-rose-600 text-white font-extrabold text-[10px] inline-block mb-1">SÍ</span>
                                                <p class="text-[11px] text-rose-600 dark:text-rose-400 font-semibold">{{ item.homework }}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="studentAgendaData.agendaItems.length === 0">
                                        <td colspan="4" class="py-6 text-center text-slate-400 italic">No hay clases programadas para este día.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Sección Inferior Individual: Asistencia, Observaciones, Méritos y Deméritos -->
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-3 p-4 bg-slate-50 dark:bg-slate-800/40 rounded-2xl border border-slate-200 dark:border-slate-700/60">
                            <!-- Sello de Asistencia -->
                            <div class="col-span-1 p-3 bg-white dark:bg-slate-800 rounded-xl border border-slate-200/80 dark:border-slate-700 text-center flex flex-col justify-center items-center">
                                <span class="text-[10px] uppercase font-bold text-slate-400 mb-1">ATTENDANCE / ASISTENCIA</span>
                                <div class="px-4 py-2 border-2 rounded-xl font-black text-sm tracking-widest uppercase transform -rotate-1 shadow-xs" :class="studentAgendaData.studentReport.attendanceCode === 1 ? 'border-emerald-600 text-emerald-600 bg-emerald-50 dark:bg-emerald-950/20' : (studentAgendaData.studentReport.attendanceCode === 0 ? 'border-rose-600 text-rose-600 bg-rose-50 dark:bg-rose-950/20' : ([2, 3, 4].includes(Number(studentAgendaData.studentReport.attendanceCode)) ? 'border-amber-600 text-amber-600 bg-amber-50 dark:bg-amber-950/20' : 'border-slate-300 text-slate-400 bg-slate-100/70 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-400'))">
                                    {{ studentAgendaData.studentReport.attendanceText }}
                                </div>
                            </div>

                            <!-- Observaciones -->
                            <div class="col-span-2 p-3 bg-white dark:bg-slate-800 rounded-xl border border-slate-200/80 dark:border-slate-700">
                                <span class="text-[10px] uppercase font-bold text-slate-400 block mb-1.5">OBSERVACIONES DEL DÍA</span>
                                <div v-if="studentAgendaData.studentReport.records && studentAgendaData.studentReport.records.filter(r => r.observations).length > 0" class="space-y-1">
                                    <p v-for="(rec, rIdx) in studentAgendaData.studentReport.records.filter(r => r.observations)" :key="rIdx" class="text-xs text-slate-700 dark:text-slate-300">
                                        <strong class="text-indigo-600 dark:text-indigo-400">[{{ rec.course ? rec.course.label : 'Docente' }}]:</strong> {{ rec.observations }}
                                    </p>
                                </div>
                                <p v-else-if="studentAgendaData.studentReport.observations" class="text-xs text-slate-700 dark:text-slate-300">
                                    {{ studentAgendaData.studentReport.observations }}
                                </p>
                                <p v-else class="text-xs text-slate-400 italic">Sin observaciones registradas hoy.</p>
                            </div>

                            <!-- Méritos y Deméritos -->
                            <div class="col-span-1 md:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-3">
                                <!-- Deméritos -->
                                <div class="p-3 bg-rose-50/50 dark:bg-rose-950/20 rounded-xl border border-rose-200 dark:border-rose-900/40">
                                    <span class="text-[10px] uppercase font-bold text-rose-500 block mb-1">DEMERITS / DEMÉRITOS</span>
                                    <div v-if="studentAgendaData.studentReport.records && studentAgendaData.studentReport.records.filter(r => r.demerit_code || r.demerits).length > 0" class="space-y-1.5">
                                        <div v-for="(rec, rIdx) in studentAgendaData.studentReport.records.filter(r => r.demerit_code || r.demerits)" :key="rIdx" class="p-1.5 rounded-lg bg-white dark:bg-slate-800 text-xs border border-rose-200/60 dark:border-rose-900/30">
                                            <span class="font-bold text-rose-600 block text-[10px] uppercase">
                                                {{ rec.demerit_code || 'FALTA' }} <span v-if="rec.course">({{ rec.course.label }})</span>
                                            </span>
                                            <span class="text-slate-700 dark:text-slate-300">{{ rec.demerits || rec.observations }}</span>
                                        </div>
                                    </div>
                                    <p v-else class="text-xs text-slate-400 italic">Sin deméritos registrados. ¡Excelente conducta!</p>
                                </div>

                                <!-- Méritos -->
                                <div class="p-3 bg-emerald-50/50 dark:bg-emerald-950/20 rounded-xl border border-emerald-200 dark:border-emerald-900/40">
                                    <span class="text-[10px] uppercase font-bold text-emerald-600 block mb-1">MERITS / MÉRITOS</span>
                                    <div v-if="studentAgendaData.studentReport.records && studentAgendaData.studentReport.records.filter(r => r.merit_code || r.merits).length > 0" class="space-y-1.5">
                                        <div v-for="(rec, rIdx) in studentAgendaData.studentReport.records.filter(r => r.merit_code || r.merits)" :key="rIdx" class="p-1.5 rounded-lg bg-white dark:bg-slate-800 text-xs border border-emerald-200/60 dark:border-emerald-900/30">
                                            <span class="font-bold text-emerald-600 block text-[10px] uppercase">
                                                {{ rec.merit_code || 'MÉRITO' }} <span v-if="rec.course">({{ rec.course.label }})</span>
                                            </span>
                                            <span class="text-slate-700 dark:text-slate-300">{{ rec.merits }}</span>
                                        </div>
                                    </div>
                                    <p v-else class="text-xs text-slate-400 italic">Sin menciones especiales registradas hoy.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 2. VISTA HORARIO SEMANAL -->
                    <div v-else-if="studentAgendaTab === 'horario'" class="space-y-3">
                        <div class="overflow-x-auto">
                            <div class="grid grid-cols-5 gap-2.5 min-w-[650px]">
                                <div v-for="day in daysOfWeekList" :key="day.id" class="flex flex-col bg-slate-50 dark:bg-slate-800/40 p-2.5 rounded-2xl border border-slate-100 dark:border-slate-800/40">
                                    <div class="text-xs font-bold text-slate-700 dark:text-slate-200 mb-2 pb-1 border-b border-slate-200/60 dark:border-slate-700/60 flex items-center justify-between">
                                        <span>{{ day.label }}</span>
                                        <span class="text-[10px] text-slate-400">
                                            {{ studentAgendaData.schedules.filter(s => s.day_of_week === day.id).length }} blq.
                                        </span>
                                    </div>

                                    <div class="space-y-1.5">
                                        <template v-for="slot in studentAgendaData.schedules.filter(s => s.day_of_week === day.id)" :key="slot.id">
                                            <!-- Recreo -->
                                            <div v-if="slot.type === 'recreo'" class="p-1.5 rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-700 dark:text-amber-400 text-center">
                                                <div class="flex items-center justify-center gap-1 text-[10px] font-bold">
                                                    <Icon icon="tabler:coffee" class="w-3 h-3" />
                                                    {{ slot.label_break || 'Recreo' }}
                                                </div>
                                                <span class="text-[9px] text-amber-600/70 font-mono">{{ slot.start_time }} - {{ slot.end_time }}</span>
                                            </div>
                                            <!-- Clase -->
                                            <div v-else class="p-2 rounded-xl bg-white dark:bg-slate-800 border border-slate-200/70 dark:border-slate-700/60 shadow-xs">
                                                <p class="text-[11px] font-bold text-slate-800 dark:text-slate-100 truncate" :title="slot.course ? slot.course.label : 'Curso'">
                                                    {{ slot.course ? slot.course.label : 'Curso' }}
                                                </p>
                                                <div class="flex items-center justify-between mt-1 text-[9px] text-slate-400 font-mono">
                                                    <span>{{ slot.start_time }}</span>
                                                    <span>-</span>
                                                    <span>{{ slot.end_time }}</span>
                                                </div>
                                            </div>
                                        </template>
                                        <div v-if="studentAgendaData.schedules.filter(s => s.day_of_week === day.id).length === 0" class="py-4 text-center text-[11px] text-slate-400 italic">
                                            Sin clases
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CardBoxModal>

        <!-- MODAL EMERGENTE OBLIGATORIO DE COMUNICADOS (AL INICIAR SESIÓN) -->
        <div
            v-if="isComunicadoPopupOpen && currentPopupComunicado"
            class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/75 backdrop-blur-sm animate-fade-in"
        >
            <div class="bg-white dark:bg-slate-900 w-full max-w-2xl rounded-3xl shadow-2xl border border-gray-100 dark:border-slate-800 overflow-hidden flex flex-col max-h-[90vh]">
                <!-- Encabezado del Modal -->
                <div class="px-6 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white flex items-center justify-between shrink-0">
                    <div class="flex items-center gap-2.5">
                        <div class="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center">
                            <Icon icon="tabler:speakerphone" class="w-5 h-5" />
                        </div>
                        <div>
                            <h3 class="font-bold text-base leading-tight">Comunicado Institucional</h3>
                            <p class="text-xs text-indigo-100">Atención a la comunidad educativa</p>
                        </div>
                    </div>
                    <!-- Indicador si hay múltiples comunicados -->
                    <div v-if="pendingComunicados.length > 1" class="text-xs bg-white/20 px-3 py-1 rounded-full font-semibold">
                        {{ selectedPopupIndex + 1 }} de {{ pendingComunicados.length }}
                    </div>
                </div>

                <!-- Pestañas de comunicados si hay más de 1 -->
                <div v-if="pendingComunicados.length > 1" class="px-6 pt-3 pb-1 bg-slate-50 dark:bg-slate-800/60 border-b border-gray-100 dark:border-slate-800 flex gap-2 overflow-x-auto shrink-0">
                    <button
                        v-for="(com, cIdx) in pendingComunicados"
                        :key="com.id"
                        type="button"
                        @click="selectPopupComunicado(cIdx)"
                        class="px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition flex items-center gap-1.5"
                        :class="selectedPopupIndex === cIdx ? 'bg-indigo-600 text-white shadow-sm' : 'bg-white dark:bg-slate-800 text-gray-600 dark:text-gray-300 hover:bg-gray-100 border border-gray-200 dark:border-slate-700'"
                    >
                        <span>Comunicado {{ cIdx + 1 }}</span>
                        <Icon v-if="com.requires_acceptance" icon="tabler:alert-circle" class="w-3.5 h-3.5 text-amber-300" />
                    </button>
                </div>

                <!-- Contenedor con Scroll para Lectura Obligatoria -->
                <div
                    ref="popupScrollContainer"
                    @scroll="handlePopupScroll"
                    class="p-6 overflow-y-auto space-y-4 flex-1 overscroll-contain"
                >
                    <!-- Título del Comunicado -->
                    <div class="border-b border-gray-100 dark:border-slate-800 pb-3">
                        <div class="flex items-center gap-2 mb-1.5">
                            <span v-if="currentPopupComunicado.requires_acceptance" class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-bold bg-rose-100 text-rose-700 dark:bg-rose-900/60 dark:text-rose-300">
                                <Icon icon="tabler:alert-triangle" class="w-3.5 h-3.5" />
                                Aceptación Obligatoria
                            </span>
                            <span class="inline-flex items-center gap-1 text-[11px] text-gray-500 dark:text-gray-400">
                                <Icon icon="tabler:calendar" class="w-3.5 h-3.5" />
                                Vigente hasta: {{ formatLocalDate(currentPopupComunicado.end_date) }}
                            </span>
                        </div>
                        <h2 class="text-xl font-bold text-gray-900 dark:text-white">
                            {{ currentPopupComunicado.title }}
                        </h2>
                    </div>

                    <!-- Imagen incrustada en cuerpo si está habilitada -->
                    <div
                        v-if="currentPopupComunicado.show_image_in_body && currentPopupComunicado.file_type === 'image' && currentPopupComunicado.file_path"
                        class="rounded-2xl overflow-hidden border border-gray-200 dark:border-slate-700 bg-gray-50 dark:bg-slate-950"
                    >
                        <img
                            :src="currentPopupComunicado.file_path"
                            alt="Imagen del comunicado"
                            class="w-full max-h-[380px] object-contain mx-auto"
                        />
                    </div>

                    <!-- Texto del comunicado -->
                    <div class="text-sm text-gray-700 dark:text-gray-300 leading-relaxed whitespace-pre-line py-1">
                        {{ currentPopupComunicado.description }}
                    </div>

                    <!-- Archivo adjunto descargable (PDF o archivo no incrustado) -->
                    <div
                        v-if="currentPopupComunicado.file_path && (!currentPopupComunicado.show_image_in_body || currentPopupComunicado.file_type !== 'image')"
                        class="p-3.5 rounded-xl bg-gray-50 dark:bg-slate-800/80 border border-gray-200 dark:border-slate-700 flex items-center justify-between"
                    >
                        <div class="flex items-center gap-3">
                            <div class="w-10 h-10 rounded-lg flex items-center justify-center bg-rose-100 text-rose-600">
                                <Icon icon="tabler:file-text" class="w-6 h-6" />
                            </div>
                            <div>
                                <p class="text-xs font-semibold text-gray-800 dark:text-gray-200">
                                    {{ currentPopupComunicado.file_name || 'Documento adjunto' }}
                                </p>
                                <p class="text-[11px] text-gray-400">Haga clic para ver o descargar el documento completo</p>
                            </div>
                        </div>
                        <a
                            :href="currentPopupComunicado.file_path"
                            target="_blank"
                            class="px-3 py-1.5 bg-white dark:bg-slate-700 hover:bg-gray-100 text-indigo-600 dark:text-indigo-300 text-xs font-semibold rounded-lg border border-gray-200 dark:border-slate-600 flex items-center gap-1 shadow-xs transition"
                        >
                            <Icon icon="tabler:download" class="w-4 h-4" />
                            Descargar
                        </a>
                    </div>

                    <!-- Casilla de Aceptación (si el comunicado lo requiere) -->
                    <div
                        v-if="currentPopupComunicado.requires_acceptance"
                        class="mt-4 p-4 rounded-2xl bg-amber-50/60 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-900/40"
                    >
                        <label class="flex items-start gap-3 cursor-pointer select-none">
                            <input
                                v-model="popupAcceptanceChecked"
                                type="checkbox"
                                :disabled="!hasScrolledToBottom"
                                class="mt-0.5 w-4 h-4 rounded text-indigo-600 focus:ring-indigo-500 border-gray-300 disabled:opacity-40 cursor-pointer"
                            />
                            <div>
                                <span class="text-xs font-bold text-gray-800 dark:text-gray-200 block">
                                    {{ currentPopupComunicado.acceptance_text }}
                                </span>
                                <p v-if="!hasScrolledToBottom" class="text-[11px] text-amber-700 dark:text-amber-400 mt-0.5">
                                    * Primero debe deslizar hasta el final del contenido para poder marcar esta casilla.
                                </p>
                            </div>
                        </label>
                    </div>

                    <div id="popup-bottom-anchor" class="h-2"></div>
                </div>

                <!-- Pie del Modal con control de habilitación de botón -->
                <div class="px-6 py-4 bg-gray-50 dark:bg-slate-800/80 border-t border-gray-100 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3 shrink-0">
                    <div class="text-xs">
                        <span v-if="!hasScrolledToBottom" class="text-amber-600 dark:text-amber-400 flex items-center gap-1.5 font-medium">
                            <Icon icon="tabler:arrow-down" class="w-4 h-4 animate-bounce shrink-0" />
                            Deslice hasta el final del comunicado para habilitar el botón.
                        </span>
                        <span v-else-if="currentPopupComunicado.requires_acceptance && !popupAcceptanceChecked" class="text-rose-600 dark:text-rose-400 flex items-center gap-1.5 font-medium">
                            <Icon icon="tabler:checkbox" class="w-4 h-4 shrink-0" />
                            Marque la casilla de aceptación para continuar.
                        </span>
                        <span v-else class="text-emerald-600 dark:text-emerald-400 flex items-center gap-1.5 font-medium">
                            <Icon icon="tabler:check" class="w-4 h-4 shrink-0" />
                            Listo para confirmar.
                        </span>
                    </div>

                    <button
                        type="button"
                        :disabled="!canAcceptCurrentComunicado || isSubmittingAcceptance"
                        @click="acceptCurrentComunicado"
                        class="w-full sm:w-auto px-6 py-2.5 rounded-xl text-sm font-bold text-white transition flex items-center justify-center gap-2 shadow-sm"
                        :class="canAcceptCurrentComunicado && !isSubmittingAcceptance ? 'bg-indigo-600 hover:bg-indigo-700 shadow-indigo-500/20' : 'bg-gray-300 dark:bg-slate-700 text-gray-500 cursor-not-allowed'"
                    >
                        <Icon v-if="isSubmittingAcceptance" icon="tabler:loader-2" class="w-4 h-4 animate-spin" />
                        <Icon v-else icon="tabler:check" class="w-4 h-4" />
                        <span>
                            {{ selectedPopupIndex < pendingComunicados.length - 1 ? 'Aceptar y Siguiente' : 'Aceptar y Cerrar' }}
                        </span>
                    </button>
                </div>
            </div>
        </div>

        <!-- MODAL DE DETALLE DE COMUNICADO (DESDE EL WIDGET) -->
        <CardBoxModal
            v-model="isComunicadoDetailOpen"
            title="Detalle del Comunicado"
            button="info"
            buttonLabel="Cerrar"
            :has-cancel="false"
        >
            <div v-if="selectedComunicado" class="space-y-4 max-h-[70vh] overflow-y-auto pr-1">
                <div class="border-b border-gray-100 dark:border-slate-800 pb-3">
                    <div class="flex items-center gap-2 mb-1.5">
                        <span v-if="selectedComunicado.requires_acceptance" class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-bold bg-amber-100 text-amber-700 dark:bg-amber-900/60 dark:text-amber-300">
                            <Icon icon="tabler:alert-circle" class="w-3.5 h-3.5" />
                            Comunicado Oficial
                        </span>
                        <span class="inline-flex items-center gap-1 text-[11px] text-gray-500 dark:text-gray-400">
                            <Icon icon="tabler:calendar" class="w-3.5 h-3.5" />
                            Vigente hasta: {{ formatLocalDate(selectedComunicado.end_date) }}
                        </span>
                    </div>
                    <h2 class="text-lg font-bold text-gray-900 dark:text-white">
                        {{ selectedComunicado.title }}
                    </h2>
                </div>

                <!-- Imagen incrustada -->
                <div
                    v-if="selectedComunicado.show_image_in_body && selectedComunicado.file_type === 'image' && selectedComunicado.file_path"
                    class="rounded-xl overflow-hidden border border-gray-200 dark:border-slate-700 bg-gray-50 dark:bg-slate-950"
                >
                    <img
                        :src="selectedComunicado.file_path"
                        alt="Imagen del comunicado"
                        class="w-full max-h-80 object-contain mx-auto"
                    />
                </div>

                <!-- Contenido -->
                <div class="text-sm text-gray-700 dark:text-gray-300 leading-relaxed whitespace-pre-line">
                    {{ selectedComunicado.description }}
                </div>

                <!-- Archivo adjunto -->
                <div
                    v-if="selectedComunicado.file_path"
                    class="p-3 bg-gray-50 dark:bg-slate-800/80 rounded-xl border border-gray-200 dark:border-slate-700 flex items-center justify-between"
                >
                    <div class="flex items-center gap-3">
                        <div class="w-9 h-9 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center">
                            <Icon icon="tabler:file-text" class="w-5 h-5" />
                        </div>
                        <div>
                            <p class="text-xs font-semibold text-gray-800 dark:text-gray-200">
                                {{ selectedComunicado.file_name || 'Archivo adjunto' }}
                            </p>
                            <p class="text-[11px] text-gray-400">Ver o descargar archivo</p>
                        </div>
                    </div>
                    <a
                        :href="selectedComunicado.file_path"
                        target="_blank"
                        class="px-3 py-1.5 bg-indigo-600 hover:bg-indigo-700 text-white text-xs font-semibold rounded-lg flex items-center gap-1 shadow-xs transition"
                    >
                        <Icon icon="tabler:download" class="w-3.5 h-3.5" />
                        Descargar
                    </a>
                </div>
            </div>
        </CardBoxModal>
    </BreezeAuthenticatedLayout>
</template>
